
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// biome-ignore-all lint: generated file
// @ts-nocheck 
/*
 * WARNING: This is an internal file that is subject to change!
 *
 * 🛑 Under no circumstances should you import this file directly! 🛑
 *
 * All exports from this file are wrapped under a `Prisma` namespace object in the browser.ts file.
 * While this enables partial backward compatibility, it is not part of the stable public API.
 *
 * If you are looking for your Models, Enums, and Input Types, please import them from the respective
 * model files in the `model` directory!
 */

import * as runtime from "@prisma/client/runtime/index-browser"

export type * from '../models.js'
export type * from './prismaNamespace.js'

export const Decimal = runtime.Decimal


export const NullTypes = {
  DbNull: runtime.objectEnumValues.classes.DbNull as (new (secret: never) => typeof runtime.objectEnumValues.instances.DbNull),
  JsonNull: runtime.objectEnumValues.classes.JsonNull as (new (secret: never) => typeof runtime.objectEnumValues.instances.JsonNull),
  AnyNull: runtime.objectEnumValues.classes.AnyNull as (new (secret: never) => typeof runtime.objectEnumValues.instances.AnyNull),
}
/**
 * Helper for filtering JSON entries that have `null` on the database (empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const DbNull = runtime.objectEnumValues.instances.DbNull
/**
 * Helper for filtering JSON entries that have JSON `null` values (not empty on the db)
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const JsonNull = runtime.objectEnumValues.instances.JsonNull
/**
 * Helper for filtering JSON entries that are `Prisma.DbNull` or `Prisma.JsonNull`
 *
 * @see https://www.prisma.io/docs/concepts/components/prisma-client/working-with-fields/working-with-json-fields#filtering-on-a-json-field
 */
export const AnyNull = runtime.objectEnumValues.instances.AnyNull


export const ModelName = {
  Institution: 'Institution',
  SocietyUser: 'SocietyUser',
  Product: 'Product',
  ContactInformation: 'ContactInformation',
  RefProfileStatus: 'RefProfileStatus',
  ProfileAddress: 'ProfileAddress',
  ConferenceGroupedRegistration: 'ConferenceGroupedRegistration',
  CertificationInstance: 'CertificationInstance',
  ConferenceRegistration: 'ConferenceRegistration',
  Membership: 'Membership',
  RefMembershipStatus: 'RefMembershipStatus',
  ProfileTag: 'ProfileTag',
  SocietySettingAdmin: 'SocietySettingAdmin',
  Society: 'Society',
  GroupMember: 'GroupMember',
  SocietyTag: 'SocietyTag',
  PaymentInvoiceItem: 'PaymentInvoiceItem',
  SubmissionInstance: 'SubmissionInstance',
  EmailHistory: 'EmailHistory',
  AppRouteConfig: 'AppRouteConfig',
  VenueRoom: 'VenueRoom',
  VenueRoomCombination: 'VenueRoomCombination',
  ConferenceEvent: 'ConferenceEvent',
  Workflow: 'Workflow',
  Group: 'Group',
  Address: 'Address',
  SalesTax: 'SalesTax',
  CreatedModified: 'CreatedModified',
  WorkflowInstancePayload: 'WorkflowInstancePayload',
  Profile: 'Profile',
  WorkflowInstance: 'WorkflowInstance',
  EducationInstance: 'EducationInstance',
  Invoice: 'Invoice',
  InvoiceItem: 'InvoiceItem',
  Payment: 'Payment',
  AIChatbotHistory: 'AIChatbotHistory',
  ActivityLog: 'ActivityLog',
  AdminNote: 'AdminNote',
  AdminSociety: 'AdminSociety',
  AdminSocietyDashboardPage: 'AdminSocietyDashboardPage',
  AdminStaffNote: 'AdminStaffNote',
  AdminStaffTimeline: 'AdminStaffTimeline',
  AdminUser: 'AdminUser',
  AdminUserJWT: 'AdminUserJWT',
  AppRouteConfigTagEvery: 'AppRouteConfigTagEvery',
  AppRouteConfigTagNone: 'AppRouteConfigTagNone',
  AppRouteConfigTagSome: 'AppRouteConfigTagSome',
  AuthnetSettlementBatch: 'AuthnetSettlementBatch',
  AutomatedTask: 'AutomatedTask',
  AutomatedTaskRun: 'AutomatedTaskRun',
  WorkflowInstanceBatch: 'WorkflowInstanceBatch',
  IntegrationQueue: 'IntegrationQueue',
  IntegrationApiRequest: 'IntegrationApiRequest',
  CertificationDefinition: 'CertificationDefinition',
  CertificationDefinitionRequirement: 'CertificationDefinitionRequirement',
  CertificationDefinitionRequirementUserSubmitEveryTag: 'CertificationDefinitionRequirementUserSubmitEveryTag',
  CertificationDefinitionRequirementUserSubmitNoneTag: 'CertificationDefinitionRequirementUserSubmitNoneTag',
  CertificationDefinitionRequirementUserSubmitSomeTag: 'CertificationDefinitionRequirementUserSubmitSomeTag',
  CertificationDefinitionTag: 'CertificationDefinitionTag',
  CertificationDefinitionUserSubmitEveryTag: 'CertificationDefinitionUserSubmitEveryTag',
  CertificationDefinitionUserSubmitNoneTag: 'CertificationDefinitionUserSubmitNoneTag',
  CertificationDefinitionUserSubmitSomeTag: 'CertificationDefinitionUserSubmitSomeTag',
  Chat: 'Chat',
  ChatMessage: 'ChatMessage',
  ChatParticipant: 'ChatParticipant',
  ChatRecipient: 'ChatRecipient',
  Conference: 'Conference',
  ConferenceBadgePrint: 'ConferenceBadgePrint',
  ConferenceBadgeTemplate: 'ConferenceBadgeTemplate',
  ConferenceCheckIn: 'ConferenceCheckIn',
  ConferenceDay: 'ConferenceDay',
  ConferenceEventParticipant: 'ConferenceEventParticipant',
  ConferenceEventRoomSetup: 'ConferenceEventRoomSetup',
  ConferenceEventSubmissionInstance: 'ConferenceEventSubmissionInstance',
  ConferenceEventTag: 'ConferenceEventTag',
  ConferenceEventTagEvery: 'ConferenceEventTagEvery',
  ConferenceEventTagNone: 'ConferenceEventTagNone',
  ConferenceEventTagSome: 'ConferenceEventTagSome',
  ConferenceEventTemplate: 'ConferenceEventTemplate',
  ConferenceGroupedRegistrant: 'ConferenceGroupedRegistrant',
  ConferenceRegistrationOptional: 'ConferenceRegistrationOptional',
  ConferenceRoom: 'ConferenceRoom',
  ConferenceTag: 'ConferenceTag',
  ConferenceVenue: 'ConferenceVenue',
  ContactInformationUse: 'ContactInformationUse',
  ContentPage: 'ContentPage',
  ContentPageTagEvery: 'ContentPageTagEvery',
  ContentPageTagNone: 'ContentPageTagNone',
  ContentPageTagSome: 'ContentPageTagSome',
  CustomReport: 'CustomReport',
  DataDeleted: 'DataDeleted',
  Directory: 'Directory',
  DiscountCode: 'DiscountCode',
  DiscountProduct: 'DiscountProduct',
  DiscountTag: 'DiscountTag',
  DiscussionForum: 'DiscussionForum',
  DynamicInvoiceItemTag: 'DynamicInvoiceItemTag',
  EducationDefinition: 'EducationDefinition',
  EducationDefinitionProduct: 'EducationDefinitionProduct',
  EducationDefinitionTag: 'EducationDefinitionTag',
  EducationDefinitionUserSubmitEveryTag: 'EducationDefinitionUserSubmitEveryTag',
  EducationDefinitionUserSubmitNoneTag: 'EducationDefinitionUserSubmitNoneTag',
  EducationDefinitionUserSubmitSomeTag: 'EducationDefinitionUserSubmitSomeTag',
  EducationInstanceFile: 'EducationInstanceFile',
  EmailOptOutPreferences: 'EmailOptOutPreferences',
  EmailTemplate: 'EmailTemplate',
  Errant: 'Errant',
  FeedbackCategory: 'FeedbackCategory',
  File: 'File',
  FileSlug: 'FileSlug',
  Form: 'Form',
  ForumPost: 'ForumPost',
  GroupFile: 'GroupFile',
  GroupMeeting: 'GroupMeeting',
  GroupTag: 'GroupTag',
  InstitutionSocietyUserRelation: 'InstitutionSocietyUserRelation',
  Interaction: 'Interaction',
  InvoiceItemDiscount: 'InvoiceItemDiscount',
  PaymentSalesTax: 'PaymentSalesTax',
  PostSentiment: 'PostSentiment',
  ProductGroupMember: 'ProductGroupMember',
  ProductInventory: 'ProductInventory',
  ProfileAddressUse: 'ProfileAddressUse',
  ProfileFile: 'ProfileFile',
  ProfileMembershipStatus: 'ProfileMembershipStatus',
  ReconciliationBatch: 'ReconciliationBatch',
  RefConferenceEventType: 'RefConferenceEventType',
  RefDiscountCategory: 'RefDiscountCategory',
  RefEmailTemplateType: 'RefEmailTemplateType',
  RefGroupMeetingType: 'RefGroupMeetingType',
  RefGroupRole: 'RefGroupRole',
  RefGroupType: 'RefGroupType',
  RefInstitutionSocietyUserRelationType: 'RefInstitutionSocietyUserRelationType',
  RefInstitutionType: 'RefInstitutionType',
  RefInteractionType: 'RefInteractionType',
  RefProductGroup: 'RefProductGroup',
  RefProductType: 'RefProductType',
  RefProfileAddressAndContactInformationType: 'RefProfileAddressAndContactInformationType',
  RefProfileAddressAndContactInformationUse: 'RefProfileAddressAndContactInformationUse',
  RefSocietySubmissionType: 'RefSocietySubmissionType',
  RefSocietyUserRelationType: 'RefSocietyUserRelationType',
  ReviewInstance: 'ReviewInstance',
  ReviewInstanceAssignment: 'ReviewInstanceAssignment',
  ReviewInstanceVote: 'ReviewInstanceVote',
  ReviewReport: 'ReviewReport',
  ReviewSession: 'ReviewSession',
  ReviewSessionFile: 'ReviewSessionFile',
  ReviewSessionMember: 'ReviewSessionMember',
  ReviewSessionSubmissionDefintion: 'ReviewSessionSubmissionDefintion',
  SSOConfig: 'SSOConfig',
  SSOJournalConfig: 'SSOJournalConfig',
  SSOJournalElsiverConfig: 'SSOJournalElsiverConfig',
  SSOJournalSageConfig: 'SSOJournalSageConfig',
  SSOJournalWileyConfig: 'SSOJournalWileyConfig',
  SSOOIDCConfig: 'SSOOIDCConfig',
  SSOPathLMSConfig: 'SSOPathLMSConfig',
  SSOSAMLConfig: 'SSOSAMLConfig',
  SocietyBucket: 'SocietyBucket',
  SocietyCustomChoices: 'SocietyCustomChoices',
  SocietyCustomQuestion: 'SocietyCustomQuestion',
  SocietyDashboardModule: 'SocietyDashboardModule',
  SocietySubmissionDefinition: 'SocietySubmissionDefinition',
  SocietySubmissionDefinitionTag: 'SocietySubmissionDefinitionTag',
  SocietyUserCognitoIdentityProvider: 'SocietyUserCognitoIdentityProvider',
  SocietyUserIdentity: 'SocietyUserIdentity',
  SocietyUserIdentityProvider: 'SocietyUserIdentityProvider',
  SocietyUserLogin: 'SocietyUserLogin',
  SocietyUserRelation: 'SocietyUserRelation',
  SubmissionDefinitionFile: 'SubmissionDefinitionFile',
  TMBucket: 'TMBucket',
  TMComment: 'TMComment',
  TMSubtaskRef: 'TMSubtaskRef',
  TMSwimlane: 'TMSwimlane',
  TMTag: 'TMTag',
  TMTask: 'TMTask',
  TMTaskDependency: 'TMTaskDependency',
  TMTaskTMTag: 'TMTaskTMTag',
  Token: 'Token',
  TokenUsageFile: 'TokenUsageFile',
  TokenUsageLogin: 'TokenUsageLogin',
  Venue: 'Venue',
  VenueAddress: 'VenueAddress',
  VenueBrand: 'VenueBrand',
  VenueCombination: 'VenueCombination',
  VenueRoomLayout: 'VenueRoomLayout',
  email_opt_out_preferences: 'email_opt_out_preferences',
  SSOOIDCSession: 'SSOOIDCSession',
  OIDCTransactionHistory: 'OIDCTransactionHistory',
  OptionalProduct: 'OptionalProduct',
  CypressCoverageData: 'CypressCoverageData',
  CustomReportTagEvery: 'CustomReportTagEvery',
  CustomReportTagNone: 'CustomReportTagNone',
  CustomReportTagSome: 'CustomReportTagSome',
  SocietyDashboardModuleTagEvery: 'SocietyDashboardModuleTagEvery',
  SocietyDashboardModuleTagNone: 'SocietyDashboardModuleTagNone',
  SocietyDashboardModuleTagSome: 'SocietyDashboardModuleTagSome',
  NotificationSubscription: 'NotificationSubscription',
  WorkflowInstancePayloadHistoric: 'WorkflowInstancePayloadHistoric',
  WebSocketConnection: 'WebSocketConnection',
  NotificationEvent: 'NotificationEvent',
  NotificationEventRecipient: 'NotificationEventRecipient',
  SocietyDefaultReport: 'SocietyDefaultReport',
  ConferenceEventAttendee: 'ConferenceEventAttendee',
  ConferenceEventFavorite: 'ConferenceEventFavorite',
  RefCountry: 'RefCountry',
  RefCountryClassificationCategory: 'RefCountryClassificationCategory',
  RefCountryClassification: 'RefCountryClassification',
  ProductPricingCountryClassification: 'ProductPricingCountryClassification',
  MembershipMeta: 'MembershipMeta',
  ProfileInvoiceNote: 'ProfileInvoiceNote',
  ProfileNote: 'ProfileNote',
  ProfileNoteStandard: 'ProfileNoteStandard',
  ChatBlock: 'ChatBlock',
  McpOAuthRecord: 'McpOAuthRecord',
  McpConnection: 'McpConnection',
  McpConnectionSociety: 'McpConnectionSociety',
  McpAuditLog: 'McpAuditLog',
  McpRecipe: 'McpRecipe',
  AppRouteConfigDirectoryTableView: 'AppRouteConfigDirectoryTableView',
  AppRouteConfigCustomReportTableView: 'AppRouteConfigCustomReportTableView',
  LatestMembershipTableView: 'LatestMembershipTableView',
  MembershipTableView: 'MembershipTableView',
  SocietySettingPublic: 'SocietySettingPublic',
  DynamicProfileTagTableView: 'DynamicProfileTagTableView',
  DistinctMembershipSocietyView: 'DistinctMembershipSocietyView',
  DynamicSocietyTagTableView: 'DynamicSocietyTagTableView',
  WorkflowInstancePayloadProfileSearchTableView: 'WorkflowInstancePayloadProfileSearchTableView',
  WorkflowInstancePayloadPanelDynamicTableView: 'WorkflowInstancePayloadPanelDynamicTableView',
  WorkflowInstancePayloadDateTableView: 'WorkflowInstancePayloadDateTableView',
  WorkflowInstancePayloadScalarTableView: 'WorkflowInstancePayloadScalarTableView',
  WorkflowInstancePayloadEducationInstanceTableView: 'WorkflowInstancePayloadEducationInstanceTableView',
  InvoiceTableView: 'InvoiceTableView',
  InvoiceItemTableView: 'InvoiceItemTableView',
  InvoicePaymentTableView: 'InvoicePaymentTableView',
  FormDesignQuestionView: 'FormDesignQuestionView',
  FormDesignProductQuestionView: 'FormDesignProductQuestionView',
  FormDesignProfileSearchQuestionView: 'FormDesignProfileSearchQuestionView',
  WorkflowInstancePayloadCertificationAttributionTableView: 'WorkflowInstancePayloadCertificationAttributionTableView',
  WorkflowDefinitionTableView: 'WorkflowDefinitionTableView',
  WorkflowInstancePayloadProductTableView: 'WorkflowInstancePayloadProductTableView',
  FormDesignQuestionMetaView: 'FormDesignQuestionMetaView'
} as const

export type ModelName = (typeof ModelName)[keyof typeof ModelName]

/*
 * Enums
 */

export const TransactionIsolationLevel = runtime.makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
} as const)

export type TransactionIsolationLevel = (typeof TransactionIsolationLevel)[keyof typeof TransactionIsolationLevel]


export const InstitutionScalarFieldEnum = {
  id: 'id',
  profile_id: 'profile_id',
  type_id: 'type_id',
  name: 'name',
  slot_number: 'slot_number',
  url: 'url',
  society_id: 'society_id'
} as const

export type InstitutionScalarFieldEnum = (typeof InstitutionScalarFieldEnum)[keyof typeof InstitutionScalarFieldEnum]


export const SocietyUserScalarFieldEnum = {
  society_user_id: 'society_user_id',
  profile_id: 'profile_id',
  degree: 'degree',
  display_name: 'display_name',
  first_name: 'first_name',
  job_title: 'job_title',
  last_name: 'last_name',
  middle_name: 'middle_name',
  prefix: 'prefix',
  profession: 'profession',
  research: 'research',
  surname: 'surname',
  affiliation: 'affiliation',
  auth_invalid_before: 'auth_invalid_before',
  deceased_date: 'deceased_date',
  society_id: 'society_id',
  date_of_birth: 'date_of_birth',
  first_last_combined: 'first_last_combined'
} as const

export type SocietyUserScalarFieldEnum = (typeof SocietyUserScalarFieldEnum)[keyof typeof SocietyUserScalarFieldEnum]


export const ProductScalarFieldEnum = {
  product_id: 'product_id',
  society_id: 'society_id',
  type_id: 'type_id',
  inventory_id: 'inventory_id',
  workflow_complex_id: 'workflow_complex_id',
  name: 'name',
  sku: 'sku',
  duration_type: 'duration_type',
  recurring: 'recurring',
  range_mm_start: 'range_mm_start',
  range_dd_start: 'range_dd_start',
  range_mm_end: 'range_mm_end',
  range_dd_end: 'range_dd_end',
  length_increment: 'length_increment',
  length_multiple: 'length_multiple',
  price: 'price',
  cash_gl_account: 'cash_gl_account',
  income_gl_account: 'income_gl_account',
  classification: 'classification',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  current_sub_name: 'current_sub_name',
  archived: 'archived',
  optional_product_id: 'optional_product_id',
  product_id_as_string: 'product_id_as_string'
} as const

export type ProductScalarFieldEnum = (typeof ProductScalarFieldEnum)[keyof typeof ProductScalarFieldEnum]


export const ContactInformationScalarFieldEnum = {
  contact_information_id: 'contact_information_id',
  profile_id: 'profile_id',
  type_id: 'type_id',
  phone: 'phone',
  fax: 'fax',
  email: 'email',
  additional_info: 'additional_info',
  society_id: 'society_id',
  profile_form_question_name: 'profile_form_question_name',
  id: 'id'
} as const

export type ContactInformationScalarFieldEnum = (typeof ContactInformationScalarFieldEnum)[keyof typeof ContactInformationScalarFieldEnum]


export const RefProfileStatusScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description'
} as const

export type RefProfileStatusScalarFieldEnum = (typeof RefProfileStatusScalarFieldEnum)[keyof typeof RefProfileStatusScalarFieldEnum]


export const ProfileAddressScalarFieldEnum = {
  profile_address_id: 'profile_address_id',
  profile_id: 'profile_id',
  address_id: 'address_id',
  type_id: 'type_id',
  profile_form_question_name: 'profile_form_question_name',
  id: 'id'
} as const

export type ProfileAddressScalarFieldEnum = (typeof ProfileAddressScalarFieldEnum)[keyof typeof ProfileAddressScalarFieldEnum]


export const ConferenceGroupedRegistrationScalarFieldEnum = {
  conference_grouped_registration_id: 'conference_grouped_registration_id',
  society_id: 'society_id',
  conference_id: 'conference_id',
  primary_registrant_profile_id: 'primary_registrant_profile_id',
  workflow_instance_id: 'workflow_instance_id',
  last_modified_id: 'last_modified_id',
  created_id: 'created_id'
} as const

export type ConferenceGroupedRegistrationScalarFieldEnum = (typeof ConferenceGroupedRegistrationScalarFieldEnum)[keyof typeof ConferenceGroupedRegistrationScalarFieldEnum]


export const CertificationInstanceScalarFieldEnum = {
  certification_instance_id: 'certification_instance_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  certification_definition_id: 'certification_definition_id',
  profile_id: 'profile_id',
  workflow_instance_id: 'workflow_instance_id',
  product_id: 'product_id',
  education_instance_id: 'education_instance_id',
  template_override: 'template_override',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  override_additional_info_template: 'override_additional_info_template',
  additional_info: 'additional_info',
  completed: 'completed',
  form_id: 'form_id'
} as const

export type CertificationInstanceScalarFieldEnum = (typeof CertificationInstanceScalarFieldEnum)[keyof typeof CertificationInstanceScalarFieldEnum]


export const ConferenceRegistrationScalarFieldEnum = {
  conference_registration_id: 'conference_registration_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  conference_id: 'conference_id',
  workflow_instance_id: 'workflow_instance_id',
  registration_form_id: 'registration_form_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  primary_registration_invoiceitem_id: 'primary_registration_invoiceitem_id'
} as const

export type ConferenceRegistrationScalarFieldEnum = (typeof ConferenceRegistrationScalarFieldEnum)[keyof typeof ConferenceRegistrationScalarFieldEnum]


export const MembershipScalarFieldEnum = {
  membership_id: 'membership_id',
  profile_id: 'profile_id',
  product_id: 'product_id',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  termination_date: 'termination_date',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id',
  invoice_item_id: 'invoice_item_id',
  workflow_instance_id: 'workflow_instance_id'
} as const

export type MembershipScalarFieldEnum = (typeof MembershipScalarFieldEnum)[keyof typeof MembershipScalarFieldEnum]


export const RefMembershipStatusScalarFieldEnum = {
  ref_membership_status_id: 'ref_membership_status_id',
  society_id: 'society_id',
  description: 'description',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type RefMembershipStatusScalarFieldEnum = (typeof RefMembershipStatusScalarFieldEnum)[keyof typeof RefMembershipStatusScalarFieldEnum]


export const ProfileTagScalarFieldEnum = {
  profile_tag_id: 'profile_tag_id',
  society_tag_id: 'society_tag_id',
  profile_id: 'profile_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ProfileTagScalarFieldEnum = (typeof ProfileTagScalarFieldEnum)[keyof typeof ProfileTagScalarFieldEnum]


export const SocietySettingAdminScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  name: 'name',
  type: 'type',
  secret: 'secret',
  value: 'value'
} as const

export type SocietySettingAdminScalarFieldEnum = (typeof SocietySettingAdminScalarFieldEnum)[keyof typeof SocietySettingAdminScalarFieldEnum]


export const SocietyScalarFieldEnum = {
  id: 'id',
  profile_form_id: 'profile_form_id',
  name: 'name',
  abbreviation: 'abbreviation',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  theme: 'theme',
  address_id: 'address_id'
} as const

export type SocietyScalarFieldEnum = (typeof SocietyScalarFieldEnum)[keyof typeof SocietyScalarFieldEnum]


export const GroupMemberScalarFieldEnum = {
  group_member_id: 'group_member_id',
  profile_id: 'profile_id',
  group_id: 'group_id',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  is_on_public_roster: 'is_on_public_roster',
  group_role_id: 'group_role_id',
  notes: 'notes',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  roster_report_visible: 'roster_report_visible',
  society_id: 'society_id',
  additional_info: 'additional_info'
} as const

export type GroupMemberScalarFieldEnum = (typeof GroupMemberScalarFieldEnum)[keyof typeof GroupMemberScalarFieldEnum]


export const SocietyTagScalarFieldEnum = {
  society_tag_id: 'society_tag_id',
  society_id: 'society_id',
  tag_name: 'tag_name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  archived: 'archived',
  visible: 'visible',
  visible_admin: 'visible_admin'
} as const

export type SocietyTagScalarFieldEnum = (typeof SocietyTagScalarFieldEnum)[keyof typeof SocietyTagScalarFieldEnum]


export const PaymentInvoiceItemScalarFieldEnum = {
  id: 'id',
  invoice_item_id: 'invoice_item_id',
  payment_id: 'payment_id',
  status: 'status',
  paid_amount: 'paid_amount',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id',
  original_payment_invoice_item_id: 'original_payment_invoice_item_id',
  reconciliation_batch_id: 'reconciliation_batch_id'
} as const

export type PaymentInvoiceItemScalarFieldEnum = (typeof PaymentInvoiceItemScalarFieldEnum)[keyof typeof PaymentInvoiceItemScalarFieldEnum]


export const SubmissionInstanceScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  form_id: 'form_id',
  submission_definition_id: 'submission_definition_id',
  workflow_id: 'workflow_id',
  workflow_instance_id: 'workflow_instance_id',
  primary_profile_id: 'primary_profile_id',
  final_review_instance_id: 'final_review_instance_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  title_template: 'title_template',
  additional_info_template_short: 'additional_info_template_short',
  additional_info_template_detailed: 'additional_info_template_detailed',
  additional_info_participant_template: 'additional_info_participant_template',
  id_as_string: 'id_as_string'
} as const

export type SubmissionInstanceScalarFieldEnum = (typeof SubmissionInstanceScalarFieldEnum)[keyof typeof SubmissionInstanceScalarFieldEnum]


export const EmailHistoryScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  resent_email_id: 'resent_email_id',
  email_template_id: 'email_template_id',
  subject: 'subject',
  body: 'body',
  to_email: 'to_email',
  to_name: 'to_name',
  from_email: 'from_email',
  cc_email: 'cc_email',
  reply_to: 'reply_to',
  sent_date: 'sent_date',
  priority: 'priority',
  status: 'status',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  workflow_instance_id: 'workflow_instance_id',
  invoice_id: 'invoice_id'
} as const

export type EmailHistoryScalarFieldEnum = (typeof EmailHistoryScalarFieldEnum)[keyof typeof EmailHistoryScalarFieldEnum]


export const AppRouteConfigScalarFieldEnum = {
  app_route_config_id: 'app_route_config_id',
  society_id: 'society_id',
  label: 'label',
  is_public: 'is_public',
  url: 'url',
  nav_menu_order_num: 'nav_menu_order_num',
  component_name: 'component_name',
  route_params: 'route_params',
  created_by_id: 'created_by_id',
  last_modified_by_id: 'last_modified_by_id',
  visible_start: 'visible_start',
  visible_end: 'visible_end',
  app_route_config_parent_id: 'app_route_config_parent_id',
  external_route: 'external_route',
  open_in_new_tab: 'open_in_new_tab',
  icon_name: 'icon_name',
  nav_type: 'nav_type',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  archived: 'archived',
  platform_config: 'platform_config'
} as const

export type AppRouteConfigScalarFieldEnum = (typeof AppRouteConfigScalarFieldEnum)[keyof typeof AppRouteConfigScalarFieldEnum]


export const VenueRoomScalarFieldEnum = {
  id: 'id',
  venue_id: 'venue_id',
  room_name: 'room_name',
  dimensions: 'dimensions',
  map_url: 'map_url',
  entrances: 'entrances',
  sq_feet: 'sq_feet',
  ceiling_height: 'ceiling_height',
  max_occupancy: 'max_occupancy',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type VenueRoomScalarFieldEnum = (typeof VenueRoomScalarFieldEnum)[keyof typeof VenueRoomScalarFieldEnum]


export const VenueRoomCombinationScalarFieldEnum = {
  id: 'id',
  venue_room_id: 'venue_room_id',
  parent_venue_room_id: 'parent_venue_room_id'
} as const

export type VenueRoomCombinationScalarFieldEnum = (typeof VenueRoomCombinationScalarFieldEnum)[keyof typeof VenueRoomCombinationScalarFieldEnum]


export const ConferenceEventScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  conference_id: 'conference_id',
  parent_event_id: 'parent_event_id',
  conference_day_id: 'conference_day_id',
  event_type_id: 'event_type_id',
  conference_room_id: 'conference_room_id',
  start_time: 'start_time',
  end_time: 'end_time',
  event_name: 'event_name',
  comments: 'comments',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  additional_info: 'additional_info',
  priority: 'priority',
  override_admin_schedule_config: 'override_admin_schedule_config',
  override_hub_schedule_config: 'override_hub_schedule_config'
} as const

export type ConferenceEventScalarFieldEnum = (typeof ConferenceEventScalarFieldEnum)[keyof typeof ConferenceEventScalarFieldEnum]


export const WorkflowScalarFieldEnum = {
  workflow_id: 'workflow_id',
  society_id: 'society_id',
  workflow_name: 'workflow_name',
  workflow_definition: 'workflow_definition',
  documentation: 'documentation',
  archived: 'archived',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  email_template_id: 'email_template_id',
  initial_task: 'initial_task'
} as const

export type WorkflowScalarFieldEnum = (typeof WorkflowScalarFieldEnum)[keyof typeof WorkflowScalarFieldEnum]


export const GroupScalarFieldEnum = {
  group_id: 'group_id',
  society_id: 'society_id',
  type_id: 'type_id',
  name: 'name',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  open_enrollement: 'open_enrollement',
  open_participation: 'open_participation',
  open_volunteer: 'open_volunteer',
  has_disclosure: 'has_disclosure',
  config: 'config',
  parent_group_id: 'parent_group_id',
  notes: 'notes',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  add_group_member_workflow_id: 'add_group_member_workflow_id',
  delete_group_member_workflow_id: 'delete_group_member_workflow_id',
  update_group_member_workflow_id: 'update_group_member_workflow_id',
  update_group_workflow_id: 'update_group_workflow_id',
  additional_info: 'additional_info'
} as const

export type GroupScalarFieldEnum = (typeof GroupScalarFieldEnum)[keyof typeof GroupScalarFieldEnum]


export const AddressScalarFieldEnum = {
  address_id: 'address_id',
  line1: 'line1',
  line2: 'line2',
  line3: 'line3',
  city: 'city',
  state: 'state',
  country: 'country',
  region: 'region',
  postal_code: 'postal_code',
  latitude: 'latitude',
  longitude: 'longitude',
  id: 'id'
} as const

export type AddressScalarFieldEnum = (typeof AddressScalarFieldEnum)[keyof typeof AddressScalarFieldEnum]


export const SalesTaxScalarFieldEnum = {
  sales_tax_id: 'sales_tax_id',
  society_id: 'society_id',
  total: 'total',
  additional_information: 'additional_information',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SalesTaxScalarFieldEnum = (typeof SalesTaxScalarFieldEnum)[keyof typeof SalesTaxScalarFieldEnum]


export const CreatedModifiedScalarFieldEnum = {
  id: 'id',
  timestamp: 'timestamp',
  society_user_id: 'society_user_id',
  society_admin_id: 'society_admin_id',
  api_request_id: 'api_request_id',
  mcp_connection_id: 'mcp_connection_id'
} as const

export type CreatedModifiedScalarFieldEnum = (typeof CreatedModifiedScalarFieldEnum)[keyof typeof CreatedModifiedScalarFieldEnum]


export const WorkflowInstancePayloadScalarFieldEnum = {
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  payload: 'payload',
  profile_id: 'profile_id',
  form_id: 'form_id',
  workflow_id: 'workflow_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type WorkflowInstancePayloadScalarFieldEnum = (typeof WorkflowInstancePayloadScalarFieldEnum)[keyof typeof WorkflowInstancePayloadScalarFieldEnum]


export const ProfileScalarFieldEnum = {
  profile_id: 'profile_id',
  society_id: 'society_id',
  profile_picture: 'profile_picture',
  status_id: 'status_id',
  type: 'type',
  biography: 'biography',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  workflow_instance_id: 'workflow_instance_id',
  profile_id_as_string: 'profile_id_as_string',
  additional_info: 'additional_info'
} as const

export type ProfileScalarFieldEnum = (typeof ProfileScalarFieldEnum)[keyof typeof ProfileScalarFieldEnum]


export const WorkflowInstanceScalarFieldEnum = {
  workflow_instance_id: 'workflow_instance_id',
  society_id: 'society_id',
  workflow_id: 'workflow_id',
  parent_workflow_instance_id: 'parent_workflow_instance_id',
  profile_id: 'profile_id',
  current_state: 'current_state',
  state_history: 'state_history',
  status: 'status',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  possible_actions: 'possible_actions',
  display_status: 'display_status',
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  workflow_instance_id_as_string: 'workflow_instance_id_as_string'
} as const

export type WorkflowInstanceScalarFieldEnum = (typeof WorkflowInstanceScalarFieldEnum)[keyof typeof WorkflowInstanceScalarFieldEnum]


export const EducationInstanceScalarFieldEnum = {
  education_instance_id: 'education_instance_id',
  society_id: 'society_id',
  education_definition_id: 'education_definition_id',
  profile_id: 'profile_id',
  invoice_item_id: 'invoice_item_id',
  workflow_instance_id: 'workflow_instance_id',
  override_name: 'override_name',
  override_template: 'override_template',
  override_additional_info_template: 'override_additional_info_template',
  progress: 'progress',
  hours_earned: 'hours_earned',
  score: 'score',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  completed: 'completed',
  form_id: 'form_id'
} as const

export type EducationInstanceScalarFieldEnum = (typeof EducationInstanceScalarFieldEnum)[keyof typeof EducationInstanceScalarFieldEnum]


export const InvoiceScalarFieldEnum = {
  invoice_id: 'invoice_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  billing_id: 'billing_id',
  shipping_id: 'shipping_id',
  status: 'status',
  payment_terms: 'payment_terms',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  workflow_instance_id: 'workflow_instance_id',
  id_as_string: 'id_as_string',
  sales_tax_id: 'sales_tax_id'
} as const

export type InvoiceScalarFieldEnum = (typeof InvoiceScalarFieldEnum)[keyof typeof InvoiceScalarFieldEnum]


export const InvoiceItemScalarFieldEnum = {
  invoice_item_id: 'invoice_item_id',
  workflow_instance_id: 'workflow_instance_id',
  invoice_id: 'invoice_id',
  product_id: 'product_id',
  status: 'status',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  quantity: 'quantity',
  price: 'price',
  total: 'total',
  cash_gl_account: 'cash_gl_account',
  income_gl_account: 'income_gl_account',
  classification: 'classification',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id',
  original_invoice_item_id: 'original_invoice_item_id',
  sales_tax_id: 'sales_tax_id',
  product_name: 'product_name',
  profile_id: 'profile_id'
} as const

export type InvoiceItemScalarFieldEnum = (typeof InvoiceItemScalarFieldEnum)[keyof typeof InvoiceItemScalarFieldEnum]


export const PaymentScalarFieldEnum = {
  payment_id: 'payment_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  payment_method: 'payment_method',
  status: 'status',
  transaction_id: 'transaction_id',
  paid_amount: 'paid_amount',
  settlement_date: 'settlement_date',
  settlement_batch_id: 'settlement_batch_id',
  reconciliation_batch_id: 'reconciliation_batch_id',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  id_as_string: 'id_as_string'
} as const

export type PaymentScalarFieldEnum = (typeof PaymentScalarFieldEnum)[keyof typeof PaymentScalarFieldEnum]


export const AIChatbotHistoryScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  rating: 'rating',
  rating_comment: 'rating_comment',
  request: 'request',
  request_full: 'request_full',
  request_tokens: 'request_tokens',
  response: 'response',
  response_full: 'response_full',
  calculated_prompt_tokens: 'calculated_prompt_tokens',
  prompt_tokens: 'prompt_tokens',
  completion_tokens: 'completion_tokens',
  historic: 'historic',
  created_id: 'created_id',
  modified_id: 'modified_id'
} as const

export type AIChatbotHistoryScalarFieldEnum = (typeof AIChatbotHistoryScalarFieldEnum)[keyof typeof AIChatbotHistoryScalarFieldEnum]


export const ActivityLogScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  message: 'message',
  category: 'category',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ActivityLogScalarFieldEnum = (typeof ActivityLogScalarFieldEnum)[keyof typeof ActivityLogScalarFieldEnum]


export const AdminNoteScalarFieldEnum = {
  id: 'id',
  profile_id: 'profile_id',
  content: 'content',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type AdminNoteScalarFieldEnum = (typeof AdminNoteScalarFieldEnum)[keyof typeof AdminNoteScalarFieldEnum]


export const AdminSocietyScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  society_admin_id: 'society_admin_id',
  additional_info: 'additional_info',
  pinned_until: 'pinned_until',
  permissions: 'permissions'
} as const

export type AdminSocietyScalarFieldEnum = (typeof AdminSocietyScalarFieldEnum)[keyof typeof AdminSocietyScalarFieldEnum]


export const AdminSocietyDashboardPageScalarFieldEnum = {
  admin_society_dashboard_page_id: 'admin_society_dashboard_page_id',
  admin_society_dashboard_page_title: 'admin_society_dashboard_page_title',
  society_id: 'society_id',
  custom_report_id: 'custom_report_id',
  priority: 'priority',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type AdminSocietyDashboardPageScalarFieldEnum = (typeof AdminSocietyDashboardPageScalarFieldEnum)[keyof typeof AdminSocietyDashboardPageScalarFieldEnum]


export const AdminStaffNoteScalarFieldEnum = {
  id: 'id',
  title: 'title',
  content: 'content',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type AdminStaffNoteScalarFieldEnum = (typeof AdminStaffNoteScalarFieldEnum)[keyof typeof AdminStaffNoteScalarFieldEnum]


export const AdminStaffTimelineScalarFieldEnum = {
  id: 'id',
  due_date: 'due_date',
  completed: 'completed',
  society_id: 'society_id',
  title: 'title',
  content: 'content',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type AdminStaffTimelineScalarFieldEnum = (typeof AdminStaffTimelineScalarFieldEnum)[keyof typeof AdminStaffTimelineScalarFieldEnum]


export const AdminUserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  display_name: 'display_name',
  is_internal: 'is_internal',
  auth_invalid_before: 'auth_invalid_before',
  idp: 'idp',
  idp_value: 'idp_value',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  permissions: 'permissions',
  given_name: 'given_name',
  family_name: 'family_name',
  job_title: 'job_title',
  department: 'department',
  idp_tenant_id: 'idp_tenant_id',
  idp_synced_at: 'idp_synced_at',
  last_sign_in_at: 'last_sign_in_at',
  archived: 'archived'
} as const

export type AdminUserScalarFieldEnum = (typeof AdminUserScalarFieldEnum)[keyof typeof AdminUserScalarFieldEnum]


export const AdminUserJWTScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  society_admin_id: 'society_admin_id',
  secret: 'secret',
  permissions: 'permissions',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type AdminUserJWTScalarFieldEnum = (typeof AdminUserJWTScalarFieldEnum)[keyof typeof AdminUserJWTScalarFieldEnum]


export const AppRouteConfigTagEveryScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  app_route_config_id: 'app_route_config_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type AppRouteConfigTagEveryScalarFieldEnum = (typeof AppRouteConfigTagEveryScalarFieldEnum)[keyof typeof AppRouteConfigTagEveryScalarFieldEnum]


export const AppRouteConfigTagNoneScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  app_route_config_id: 'app_route_config_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type AppRouteConfigTagNoneScalarFieldEnum = (typeof AppRouteConfigTagNoneScalarFieldEnum)[keyof typeof AppRouteConfigTagNoneScalarFieldEnum]


export const AppRouteConfigTagSomeScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  app_route_config_id: 'app_route_config_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type AppRouteConfigTagSomeScalarFieldEnum = (typeof AppRouteConfigTagSomeScalarFieldEnum)[keyof typeof AppRouteConfigTagSomeScalarFieldEnum]


export const AuthnetSettlementBatchScalarFieldEnum = {
  authorize_settlement_batch_id: 'authorize_settlement_batch_id',
  society_id: 'society_id',
  settlement_batch_id: 'settlement_batch_id',
  settlement_state: 'settlement_state',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type AuthnetSettlementBatchScalarFieldEnum = (typeof AuthnetSettlementBatchScalarFieldEnum)[keyof typeof AuthnetSettlementBatchScalarFieldEnum]


export const AutomatedTaskScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  task_type: 'task_type',
  is_running: 'is_running',
  created_at: 'created_at',
  schedule_name: 'schedule_name'
} as const

export type AutomatedTaskScalarFieldEnum = (typeof AutomatedTaskScalarFieldEnum)[keyof typeof AutomatedTaskScalarFieldEnum]


export const AutomatedTaskRunScalarFieldEnum = {
  id: 'id',
  automated_task_id: 'automated_task_id',
  started_at: 'started_at',
  finished_at: 'finished_at',
  status: 'status',
  message: 'message',
  settled_total: 'settled_total',
  settled_at: 'settled_at'
} as const

export type AutomatedTaskRunScalarFieldEnum = (typeof AutomatedTaskRunScalarFieldEnum)[keyof typeof AutomatedTaskRunScalarFieldEnum]


export const WorkflowInstanceBatchScalarFieldEnum = {
  workflow_instance_batch_id: 'workflow_instance_batch_id',
  society_id: 'society_id',
  source: 'source',
  status: 'status',
  workflow_id: 'workflow_id',
  profile_id: 'profile_id',
  workflow_instance_id: 'workflow_instance_id',
  set_state: 'set_state',
  event_name: 'event_name',
  automated_task_run_id: 'automated_task_run_id',
  sqs_message_id: 'sqs_message_id',
  message: 'message',
  created_at: 'created_at',
  started_at: 'started_at',
  finished_at: 'finished_at'
} as const

export type WorkflowInstanceBatchScalarFieldEnum = (typeof WorkflowInstanceBatchScalarFieldEnum)[keyof typeof WorkflowInstanceBatchScalarFieldEnum]


export const IntegrationQueueScalarFieldEnum = {
  integration_queue_id: 'integration_queue_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  integration: 'integration',
  status: 'status',
  workflow_instance_id: 'workflow_instance_id',
  attempt_count: 'attempt_count',
  sqs_message_id: 'sqs_message_id',
  started_at: 'started_at',
  completed_at: 'completed_at',
  skip_reason: 'skip_reason',
  error: 'error',
  warnings: 'warnings',
  created: 'created',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type IntegrationQueueScalarFieldEnum = (typeof IntegrationQueueScalarFieldEnum)[keyof typeof IntegrationQueueScalarFieldEnum]


export const IntegrationApiRequestScalarFieldEnum = {
  integration_api_request_id: 'integration_api_request_id',
  integration_queue_id: 'integration_queue_id',
  society_id: 'society_id',
  url: 'url',
  request_method: 'request_method',
  request_headers: 'request_headers',
  request_body: 'request_body',
  response_code: 'response_code',
  response_headers: 'response_headers',
  response_body: 'response_body',
  error: 'error',
  started_at: 'started_at',
  duration_ms: 'duration_ms'
} as const

export type IntegrationApiRequestScalarFieldEnum = (typeof IntegrationApiRequestScalarFieldEnum)[keyof typeof IntegrationApiRequestScalarFieldEnum]


export const CertificationDefinitionScalarFieldEnum = {
  certification_definition_id: 'certification_definition_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  certification_name: 'certification_name',
  certificate_template: 'certificate_template',
  expiration_days: 'expiration_days',
  replacement_certification_definition_id: 'replacement_certification_definition_id',
  workflow_id: 'workflow_id',
  auto_award: 'auto_award',
  minimum_weight: 'minimum_weight',
  additional_info_template: 'additional_info_template',
  visible: 'visible',
  allow_duplicate: 'allow_duplicate',
  start_button: 'start_button',
  additional_info: 'additional_info',
  form_id: 'form_id'
} as const

export type CertificationDefinitionScalarFieldEnum = (typeof CertificationDefinitionScalarFieldEnum)[keyof typeof CertificationDefinitionScalarFieldEnum]


export const CertificationDefinitionRequirementScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  additional_information: 'additional_information',
  certification_requirement_name: 'certification_requirement_name',
  certification_definition_id: 'certification_definition_id',
  education_definition_id: 'education_definition_id',
  minimum_score: 'minimum_score',
  product_id: 'product_id',
  certification_requirement_weight: 'certification_requirement_weight'
} as const

export type CertificationDefinitionRequirementScalarFieldEnum = (typeof CertificationDefinitionRequirementScalarFieldEnum)[keyof typeof CertificationDefinitionRequirementScalarFieldEnum]


export const CertificationDefinitionRequirementUserSubmitEveryTagScalarFieldEnum = {
  id: 'id',
  certification_definition_requirement_id: 'certification_definition_requirement_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type CertificationDefinitionRequirementUserSubmitEveryTagScalarFieldEnum = (typeof CertificationDefinitionRequirementUserSubmitEveryTagScalarFieldEnum)[keyof typeof CertificationDefinitionRequirementUserSubmitEveryTagScalarFieldEnum]


export const CertificationDefinitionRequirementUserSubmitNoneTagScalarFieldEnum = {
  id: 'id',
  certification_definition_requirement_id: 'certification_definition_requirement_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type CertificationDefinitionRequirementUserSubmitNoneTagScalarFieldEnum = (typeof CertificationDefinitionRequirementUserSubmitNoneTagScalarFieldEnum)[keyof typeof CertificationDefinitionRequirementUserSubmitNoneTagScalarFieldEnum]


export const CertificationDefinitionRequirementUserSubmitSomeTagScalarFieldEnum = {
  id: 'id',
  certification_definition_requirement_id: 'certification_definition_requirement_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type CertificationDefinitionRequirementUserSubmitSomeTagScalarFieldEnum = (typeof CertificationDefinitionRequirementUserSubmitSomeTagScalarFieldEnum)[keyof typeof CertificationDefinitionRequirementUserSubmitSomeTagScalarFieldEnum]


export const CertificationDefinitionTagScalarFieldEnum = {
  id: 'id',
  certification_definition_id: 'certification_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type CertificationDefinitionTagScalarFieldEnum = (typeof CertificationDefinitionTagScalarFieldEnum)[keyof typeof CertificationDefinitionTagScalarFieldEnum]


export const CertificationDefinitionUserSubmitEveryTagScalarFieldEnum = {
  id: 'id',
  certification_definition_id: 'certification_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type CertificationDefinitionUserSubmitEveryTagScalarFieldEnum = (typeof CertificationDefinitionUserSubmitEveryTagScalarFieldEnum)[keyof typeof CertificationDefinitionUserSubmitEveryTagScalarFieldEnum]


export const CertificationDefinitionUserSubmitNoneTagScalarFieldEnum = {
  id: 'id',
  certification_definition_id: 'certification_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type CertificationDefinitionUserSubmitNoneTagScalarFieldEnum = (typeof CertificationDefinitionUserSubmitNoneTagScalarFieldEnum)[keyof typeof CertificationDefinitionUserSubmitNoneTagScalarFieldEnum]


export const CertificationDefinitionUserSubmitSomeTagScalarFieldEnum = {
  id: 'id',
  certification_definition_id: 'certification_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type CertificationDefinitionUserSubmitSomeTagScalarFieldEnum = (typeof CertificationDefinitionUserSubmitSomeTagScalarFieldEnum)[keyof typeof CertificationDefinitionUserSubmitSomeTagScalarFieldEnum]


export const ChatScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  event_id: 'event_id',
  chat_name: 'chat_name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  deleted_id: 'deleted_id'
} as const

export type ChatScalarFieldEnum = (typeof ChatScalarFieldEnum)[keyof typeof ChatScalarFieldEnum]


export const ChatMessageScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  content: 'content',
  sender_participant_id: 'sender_participant_id',
  chat_id: 'chat_id',
  read_by_participants_id: 'read_by_participants_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  deleted_id: 'deleted_id',
  is_hidden_from_recipient: 'is_hidden_from_recipient'
} as const

export type ChatMessageScalarFieldEnum = (typeof ChatMessageScalarFieldEnum)[keyof typeof ChatMessageScalarFieldEnum]


export const ChatParticipantScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  society_admin_id: 'society_admin_id',
  is_muted: 'is_muted',
  chat_id: 'chat_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ChatParticipantScalarFieldEnum = (typeof ChatParticipantScalarFieldEnum)[keyof typeof ChatParticipantScalarFieldEnum]


export const ChatRecipientScalarFieldEnum = {
  id: 'id',
  chat_participant_id: 'chat_participant_id',
  chat_message_id: 'chat_message_id',
  is_read: 'is_read',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ChatRecipientScalarFieldEnum = (typeof ChatRecipientScalarFieldEnum)[keyof typeof ChatRecipientScalarFieldEnum]


export const ConferenceScalarFieldEnum = {
  conference_id: 'conference_id',
  society_id: 'society_id',
  conference_venue_id: 'conference_venue_id',
  conference_name: 'conference_name',
  workflow_id: 'workflow_id',
  registration_form_id: 'registration_form_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  start_date: 'start_date',
  end_date: 'end_date',
  profile_conference_event_report_id: 'profile_conference_event_report_id',
  conference_event_report_id: 'conference_event_report_id',
  archived: 'archived',
  primary_registration_question_name: 'primary_registration_question_name'
} as const

export type ConferenceScalarFieldEnum = (typeof ConferenceScalarFieldEnum)[keyof typeof ConferenceScalarFieldEnum]


export const ConferenceBadgePrintScalarFieldEnum = {
  conference_badge_print_id: 'conference_badge_print_id',
  badge_data: 'badge_data',
  conference_registration_id: 'conference_registration_id',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  conference_id: 'conference_id',
  society_id: 'society_id'
} as const

export type ConferenceBadgePrintScalarFieldEnum = (typeof ConferenceBadgePrintScalarFieldEnum)[keyof typeof ConferenceBadgePrintScalarFieldEnum]


export const ConferenceBadgeTemplateScalarFieldEnum = {
  conference_badge_template_id: 'conference_badge_template_id',
  badge_template_design: 'badge_template_design',
  badge_width: 'badge_width',
  badge_height: 'badge_height',
  printer_api_url: 'printer_api_url',
  society_id: 'society_id',
  conference_id: 'conference_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceBadgeTemplateScalarFieldEnum = (typeof ConferenceBadgeTemplateScalarFieldEnum)[keyof typeof ConferenceBadgeTemplateScalarFieldEnum]


export const ConferenceCheckInScalarFieldEnum = {
  conference_check_in_id: 'conference_check_in_id',
  conference_id: 'conference_id',
  conference_registration_id: 'conference_registration_id',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id',
  profile_id: 'profile_id'
} as const

export type ConferenceCheckInScalarFieldEnum = (typeof ConferenceCheckInScalarFieldEnum)[keyof typeof ConferenceCheckInScalarFieldEnum]


export const ConferenceDayScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  conference_id: 'conference_id',
  day_name: 'day_name',
  day_start_time: 'day_start_time',
  day_end_time: 'day_end_time',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceDayScalarFieldEnum = (typeof ConferenceDayScalarFieldEnum)[keyof typeof ConferenceDayScalarFieldEnum]


export const ConferenceEventParticipantScalarFieldEnum = {
  id: 'id',
  conference_id: 'conference_id',
  conference_event_id: 'conference_event_id',
  profile_id: 'profile_id',
  conference_registration_id: 'conference_registration_id',
  submission_instance_id: 'submission_instance_id',
  role_text: 'role_text',
  priority: 'priority',
  start_time: 'start_time',
  end_time: 'end_time',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  additional_info: 'additional_info'
} as const

export type ConferenceEventParticipantScalarFieldEnum = (typeof ConferenceEventParticipantScalarFieldEnum)[keyof typeof ConferenceEventParticipantScalarFieldEnum]


export const ConferenceEventRoomSetupScalarFieldEnum = {
  id: 'id',
  conference_id: 'conference_id',
  conference_event_id: 'conference_event_id',
  stage_setup: 'stage_setup',
  av_needs: 'av_needs',
  signage_setup: 'signage_setup',
  additional_setup: 'additional_setup',
  permission_tags: 'permission_tags',
  comments: 'comments',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  room_layout_id: 'room_layout_id'
} as const

export type ConferenceEventRoomSetupScalarFieldEnum = (typeof ConferenceEventRoomSetupScalarFieldEnum)[keyof typeof ConferenceEventRoomSetupScalarFieldEnum]


export const ConferenceEventSubmissionInstanceScalarFieldEnum = {
  id: 'id',
  conference_id: 'conference_id',
  conference_event_id: 'conference_event_id',
  submission_instance_id: 'submission_instance_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  priority: 'priority',
  additional_info: 'additional_info'
} as const

export type ConferenceEventSubmissionInstanceScalarFieldEnum = (typeof ConferenceEventSubmissionInstanceScalarFieldEnum)[keyof typeof ConferenceEventSubmissionInstanceScalarFieldEnum]


export const ConferenceEventTagScalarFieldEnum = {
  id: 'id',
  conference_event_id: 'conference_event_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ConferenceEventTagScalarFieldEnum = (typeof ConferenceEventTagScalarFieldEnum)[keyof typeof ConferenceEventTagScalarFieldEnum]


export const ConferenceEventTagEveryScalarFieldEnum = {
  id: 'id',
  conference_event_id: 'conference_event_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ConferenceEventTagEveryScalarFieldEnum = (typeof ConferenceEventTagEveryScalarFieldEnum)[keyof typeof ConferenceEventTagEveryScalarFieldEnum]


export const ConferenceEventTagNoneScalarFieldEnum = {
  id: 'id',
  conference_event_id: 'conference_event_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ConferenceEventTagNoneScalarFieldEnum = (typeof ConferenceEventTagNoneScalarFieldEnum)[keyof typeof ConferenceEventTagNoneScalarFieldEnum]


export const ConferenceEventTagSomeScalarFieldEnum = {
  id: 'id',
  conference_event_id: 'conference_event_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ConferenceEventTagSomeScalarFieldEnum = (typeof ConferenceEventTagSomeScalarFieldEnum)[keyof typeof ConferenceEventTagSomeScalarFieldEnum]


export const ConferenceEventTemplateScalarFieldEnum = {
  id: 'id',
  template: 'template',
  society_id: 'society_id',
  conference_id: 'conference_id',
  conference_event_id: 'conference_event_id',
  conference_event_template_type: 'conference_event_template_type',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceEventTemplateScalarFieldEnum = (typeof ConferenceEventTemplateScalarFieldEnum)[keyof typeof ConferenceEventTemplateScalarFieldEnum]


export const ConferenceGroupedRegistrantScalarFieldEnum = {
  conference_grouped_registrant_id: 'conference_grouped_registrant_id',
  society_id: 'society_id',
  conference_registration_id: 'conference_registration_id',
  conference_grouped_registration_id: 'conference_grouped_registration_id'
} as const

export type ConferenceGroupedRegistrantScalarFieldEnum = (typeof ConferenceGroupedRegistrantScalarFieldEnum)[keyof typeof ConferenceGroupedRegistrantScalarFieldEnum]


export const ConferenceRegistrationOptionalScalarFieldEnum = {
  conference_registration_optional_id: 'conference_registration_optional_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  conference_registration_id: 'conference_registration_id',
  invoice_item_id: 'invoice_item_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceRegistrationOptionalScalarFieldEnum = (typeof ConferenceRegistrationOptionalScalarFieldEnum)[keyof typeof ConferenceRegistrationOptionalScalarFieldEnum]


export const ConferenceRoomScalarFieldEnum = {
  id: 'id',
  conference_venue_id: 'conference_venue_id',
  room_id: 'room_id',
  conference_room_name: 'conference_room_name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceRoomScalarFieldEnum = (typeof ConferenceRoomScalarFieldEnum)[keyof typeof ConferenceRoomScalarFieldEnum]


export const ConferenceTagScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  conference_id: 'conference_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ConferenceTagScalarFieldEnum = (typeof ConferenceTagScalarFieldEnum)[keyof typeof ConferenceTagScalarFieldEnum]


export const ConferenceVenueScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  venue_id: 'venue_id',
  conference_venue_name: 'conference_venue_name',
  conference_venue_address_id: 'conference_venue_address_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceVenueScalarFieldEnum = (typeof ConferenceVenueScalarFieldEnum)[keyof typeof ConferenceVenueScalarFieldEnum]


export const ContactInformationUseScalarFieldEnum = {
  contact_information_use_id: 'contact_information_use_id',
  contact_information_id: 'contact_information_id',
  use_id: 'use_id',
  profile_id: 'profile_id',
  society_id: 'society_id',
  id: 'id'
} as const

export type ContactInformationUseScalarFieldEnum = (typeof ContactInformationUseScalarFieldEnum)[keyof typeof ContactInformationUseScalarFieldEnum]


export const ContentPageScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  app_route_config_id: 'app_route_config_id',
  priority: 'priority',
  zone: 'zone',
  data: 'data',
  content: 'content',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  content_type: 'content_type',
  description: 'description'
} as const

export type ContentPageScalarFieldEnum = (typeof ContentPageScalarFieldEnum)[keyof typeof ContentPageScalarFieldEnum]


export const ContentPageTagEveryScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  content_page_id: 'content_page_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ContentPageTagEveryScalarFieldEnum = (typeof ContentPageTagEveryScalarFieldEnum)[keyof typeof ContentPageTagEveryScalarFieldEnum]


export const ContentPageTagNoneScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  content_page_id: 'content_page_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ContentPageTagNoneScalarFieldEnum = (typeof ContentPageTagNoneScalarFieldEnum)[keyof typeof ContentPageTagNoneScalarFieldEnum]


export const ContentPageTagSomeScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  content_page_id: 'content_page_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ContentPageTagSomeScalarFieldEnum = (typeof ContentPageTagSomeScalarFieldEnum)[keyof typeof ContentPageTagSomeScalarFieldEnum]


export const CustomReportScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  report_name: 'report_name',
  base_table: 'base_table',
  select_statement: 'select_statement',
  where_clause: 'where_clause',
  query_raw: 'query_raw',
  filters: 'filters',
  export_columns: 'export_columns',
  display_columns: 'display_columns',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  additional_info: 'additional_info',
  order_by_config: 'order_by_config',
  is_public: 'is_public',
  archived: 'archived',
  profile_scoped: 'profile_scoped'
} as const

export type CustomReportScalarFieldEnum = (typeof CustomReportScalarFieldEnum)[keyof typeof CustomReportScalarFieldEnum]


export const DataDeletedScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  table_name: 'table_name',
  data: 'data',
  deleted_at: 'deleted_at'
} as const

export type DataDeletedScalarFieldEnum = (typeof DataDeletedScalarFieldEnum)[keyof typeof DataDeletedScalarFieldEnum]


export const DirectoryScalarFieldEnum = {
  directory_id: 'directory_id',
  society_id: 'society_id',
  name: 'name',
  allow_contact: 'allow_contact',
  card_template: 'card_template',
  tile_template: 'tile_template',
  email_template_id: 'email_template_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  custom_report_id: 'custom_report_id'
} as const

export type DirectoryScalarFieldEnum = (typeof DirectoryScalarFieldEnum)[keyof typeof DirectoryScalarFieldEnum]


export const DiscountCodeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  discount: 'discount',
  name: 'name',
  discount_category_id: 'discount_category_id',
  code: 'code',
  discount_type: 'discount_type',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  max_useage: 'max_useage'
} as const

export type DiscountCodeScalarFieldEnum = (typeof DiscountCodeScalarFieldEnum)[keyof typeof DiscountCodeScalarFieldEnum]


export const DiscountProductScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  discount_code_id: 'discount_code_id',
  product_id: 'product_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type DiscountProductScalarFieldEnum = (typeof DiscountProductScalarFieldEnum)[keyof typeof DiscountProductScalarFieldEnum]


export const DiscountTagScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  discount_code_id: 'discount_code_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type DiscountTagScalarFieldEnum = (typeof DiscountTagScalarFieldEnum)[keyof typeof DiscountTagScalarFieldEnum]


export const DiscussionForumScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  event_id: 'event_id',
  conference_id: 'conference_id',
  group_id: 'group_id',
  forum_type: 'forum_type',
  is_public_default_value: 'is_public_default_value',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type DiscussionForumScalarFieldEnum = (typeof DiscussionForumScalarFieldEnum)[keyof typeof DiscussionForumScalarFieldEnum]


export const DynamicInvoiceItemTagScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  tag_name: 'tag_name',
  profile_id: 'profile_id',
  product_id: 'product_id',
  invoice_item_id: 'invoice_item_id'
} as const

export type DynamicInvoiceItemTagScalarFieldEnum = (typeof DynamicInvoiceItemTagScalarFieldEnum)[keyof typeof DynamicInvoiceItemTagScalarFieldEnum]


export const EducationDefinitionScalarFieldEnum = {
  education_definition_id: 'education_definition_id',
  society_id: 'society_id',
  workflow_id: 'workflow_id',
  education_name: 'education_name',
  max_hours: 'max_hours',
  additional_info_template: 'additional_info_template',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  certificate_template: 'certificate_template',
  visible: 'visible',
  allow_duplicate: 'allow_duplicate',
  start_button: 'start_button',
  form_id: 'form_id'
} as const

export type EducationDefinitionScalarFieldEnum = (typeof EducationDefinitionScalarFieldEnum)[keyof typeof EducationDefinitionScalarFieldEnum]


export const EducationDefinitionProductScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  education_definition_id: 'education_definition_id',
  product_id: 'product_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type EducationDefinitionProductScalarFieldEnum = (typeof EducationDefinitionProductScalarFieldEnum)[keyof typeof EducationDefinitionProductScalarFieldEnum]


export const EducationDefinitionTagScalarFieldEnum = {
  id: 'id',
  education_definition_id: 'education_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type EducationDefinitionTagScalarFieldEnum = (typeof EducationDefinitionTagScalarFieldEnum)[keyof typeof EducationDefinitionTagScalarFieldEnum]


export const EducationDefinitionUserSubmitEveryTagScalarFieldEnum = {
  id: 'id',
  education_definition_id: 'education_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type EducationDefinitionUserSubmitEveryTagScalarFieldEnum = (typeof EducationDefinitionUserSubmitEveryTagScalarFieldEnum)[keyof typeof EducationDefinitionUserSubmitEveryTagScalarFieldEnum]


export const EducationDefinitionUserSubmitNoneTagScalarFieldEnum = {
  id: 'id',
  education_definition_id: 'education_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type EducationDefinitionUserSubmitNoneTagScalarFieldEnum = (typeof EducationDefinitionUserSubmitNoneTagScalarFieldEnum)[keyof typeof EducationDefinitionUserSubmitNoneTagScalarFieldEnum]


export const EducationDefinitionUserSubmitSomeTagScalarFieldEnum = {
  id: 'id',
  education_definition_id: 'education_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type EducationDefinitionUserSubmitSomeTagScalarFieldEnum = (typeof EducationDefinitionUserSubmitSomeTagScalarFieldEnum)[keyof typeof EducationDefinitionUserSubmitSomeTagScalarFieldEnum]


export const EducationInstanceFileScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  education_instance_id: 'education_instance_id',
  file_id: 'file_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type EducationInstanceFileScalarFieldEnum = (typeof EducationInstanceFileScalarFieldEnum)[keyof typeof EducationInstanceFileScalarFieldEnum]


export const EmailOptOutPreferencesScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  contact_information_id: 'contact_information_id',
  email: 'email',
  preference: 'preference',
  has_opted_in: 'has_opted_in',
  reason: 'reason',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type EmailOptOutPreferencesScalarFieldEnum = (typeof EmailOptOutPreferencesScalarFieldEnum)[keyof typeof EmailOptOutPreferencesScalarFieldEnum]


export const EmailTemplateScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  email_subject: 'email_subject',
  name: 'name',
  template_html: 'template_html',
  template_type_id: 'template_type_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  archived: 'archived'
} as const

export type EmailTemplateScalarFieldEnum = (typeof EmailTemplateScalarFieldEnum)[keyof typeof EmailTemplateScalarFieldEnum]


export const ErrantScalarFieldEnum = {
  id: 'id',
  pipeline_name: 'pipeline_name',
  records: 'records',
  error_message: 'error_message',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ErrantScalarFieldEnum = (typeof ErrantScalarFieldEnum)[keyof typeof ErrantScalarFieldEnum]


export const FeedbackCategoryScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  category: 'category',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type FeedbackCategoryScalarFieldEnum = (typeof FeedbackCategoryScalarFieldEnum)[keyof typeof FeedbackCategoryScalarFieldEnum]


export const FileScalarFieldEnum = {
  file_id: 'file_id',
  custom_file_name: 'custom_file_name',
  content_type: 'content_type',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id',
  original_file_name: 'original_file_name',
  is_public: 'is_public'
} as const

export type FileScalarFieldEnum = (typeof FileScalarFieldEnum)[keyof typeof FileScalarFieldEnum]


export const FileSlugScalarFieldEnum = {
  file_slug_id: 'file_slug_id',
  file_id: 'file_id',
  society_id: 'society_id',
  file_slug_name: 'file_slug_name'
} as const

export type FileSlugScalarFieldEnum = (typeof FileSlugScalarFieldEnum)[keyof typeof FileSlugScalarFieldEnum]


export const FormScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  form_design: 'form_design',
  title: 'title',
  category: 'category',
  archived: 'archived',
  locked: 'locked',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type FormScalarFieldEnum = (typeof FormScalarFieldEnum)[keyof typeof FormScalarFieldEnum]


export const ForumPostScalarFieldEnum = {
  id: 'id',
  discussion_forum_id: 'discussion_forum_id',
  profile_id: 'profile_id',
  post_id: 'post_id',
  message: 'message',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  is_public: 'is_public',
  is_deleted: 'is_deleted'
} as const

export type ForumPostScalarFieldEnum = (typeof ForumPostScalarFieldEnum)[keyof typeof ForumPostScalarFieldEnum]


export const GroupFileScalarFieldEnum = {
  id: 'id',
  file_id: 'file_id',
  group_id: 'group_id'
} as const

export type GroupFileScalarFieldEnum = (typeof GroupFileScalarFieldEnum)[keyof typeof GroupFileScalarFieldEnum]


export const GroupMeetingScalarFieldEnum = {
  id: 'id',
  group_id: 'group_id',
  type_id: 'type_id',
  recurring: 'recurring',
  name: 'name',
  link: 'link',
  notes: 'notes',
  date_time: 'date_time',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type GroupMeetingScalarFieldEnum = (typeof GroupMeetingScalarFieldEnum)[keyof typeof GroupMeetingScalarFieldEnum]


export const GroupTagScalarFieldEnum = {
  id: 'id',
  society_tag_id: 'society_tag_id',
  group_id: 'group_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type GroupTagScalarFieldEnum = (typeof GroupTagScalarFieldEnum)[keyof typeof GroupTagScalarFieldEnum]


export const InstitutionSocietyUserRelationScalarFieldEnum = {
  id: 'id',
  institution_id: 'institution_id',
  society_user_id: 'society_user_id',
  type_id: 'type_id',
  copy_on_email: 'copy_on_email'
} as const

export type InstitutionSocietyUserRelationScalarFieldEnum = (typeof InstitutionSocietyUserRelationScalarFieldEnum)[keyof typeof InstitutionSocietyUserRelationScalarFieldEnum]


export const InteractionScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  type_id: 'type_id',
  data: 'data',
  form_design: 'form_design',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type InteractionScalarFieldEnum = (typeof InteractionScalarFieldEnum)[keyof typeof InteractionScalarFieldEnum]


export const InvoiceItemDiscountScalarFieldEnum = {
  id: 'id',
  invoice_item_id: 'invoice_item_id',
  discount_code_id: 'discount_code_id',
  total_discount: 'total_discount',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type InvoiceItemDiscountScalarFieldEnum = (typeof InvoiceItemDiscountScalarFieldEnum)[keyof typeof InvoiceItemDiscountScalarFieldEnum]


export const PaymentSalesTaxScalarFieldEnum = {
  payment_sales_tax_id: 'payment_sales_tax_id',
  society_id: 'society_id',
  sales_tax_id: 'sales_tax_id',
  payment_id: 'payment_id',
  paid_amount: 'paid_amount',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  original_payment_sales_tax_id: 'original_payment_sales_tax_id'
} as const

export type PaymentSalesTaxScalarFieldEnum = (typeof PaymentSalesTaxScalarFieldEnum)[keyof typeof PaymentSalesTaxScalarFieldEnum]


export const PostSentimentScalarFieldEnum = {
  id: 'id',
  post_id: 'post_id',
  profile_id: 'profile_id',
  sentiment_type: 'sentiment_type',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type PostSentimentScalarFieldEnum = (typeof PostSentimentScalarFieldEnum)[keyof typeof PostSentimentScalarFieldEnum]


export const ProductGroupMemberScalarFieldEnum = {
  id: 'id',
  product_id: 'product_id',
  productgroup_id: 'productgroup_id'
} as const

export type ProductGroupMemberScalarFieldEnum = (typeof ProductGroupMemberScalarFieldEnum)[keyof typeof ProductGroupMemberScalarFieldEnum]


export const ProductInventoryScalarFieldEnum = {
  id: 'id',
  amount: 'amount',
  is_fixed: 'is_fixed',
  row_effective: 'row_effective',
  row_expiration: 'row_expiration'
} as const

export type ProductInventoryScalarFieldEnum = (typeof ProductInventoryScalarFieldEnum)[keyof typeof ProductInventoryScalarFieldEnum]


export const ProfileAddressUseScalarFieldEnum = {
  profile_address_use_id: 'profile_address_use_id',
  profile_id: 'profile_id',
  profile_address_id: 'profile_address_id',
  use_id: 'use_id',
  id: 'id'
} as const

export type ProfileAddressUseScalarFieldEnum = (typeof ProfileAddressUseScalarFieldEnum)[keyof typeof ProfileAddressUseScalarFieldEnum]


export const ProfileFileScalarFieldEnum = {
  id: 'id',
  file_id: 'file_id',
  profile_id: 'profile_id'
} as const

export type ProfileFileScalarFieldEnum = (typeof ProfileFileScalarFieldEnum)[keyof typeof ProfileFileScalarFieldEnum]


export const ProfileMembershipStatusScalarFieldEnum = {
  profile_membership_status_id: 'profile_membership_status_id',
  profile_id: 'profile_id',
  ref_membership_status_id: 'ref_membership_status_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ProfileMembershipStatusScalarFieldEnum = (typeof ProfileMembershipStatusScalarFieldEnum)[keyof typeof ProfileMembershipStatusScalarFieldEnum]


export const ReconciliationBatchScalarFieldEnum = {
  reconciliation_batch_id: 'reconciliation_batch_id',
  quickbooks_online_journal_entry_id: 'quickbooks_online_journal_entry_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ReconciliationBatchScalarFieldEnum = (typeof ReconciliationBatchScalarFieldEnum)[keyof typeof ReconciliationBatchScalarFieldEnum]


export const RefConferenceEventTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description',
  event_type_icon: 'event_type_icon',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  conference_id: 'conference_id',
  schedule_main_template: 'schedule_main_template',
  schedule_sub_template: 'schedule_sub_template',
  header_main_template: 'header_main_template',
  header_sub_template: 'header_sub_template',
  body_template: 'body_template',
  banner_template: 'banner_template',
  additional_info_form_design: 'additional_info_form_design',
  css: 'css',
  admin_schedule_config: 'admin_schedule_config',
  hub_schedule_config: 'hub_schedule_config',
  schedule_builder_submission_config: 'schedule_builder_submission_config'
} as const

export type RefConferenceEventTypeScalarFieldEnum = (typeof RefConferenceEventTypeScalarFieldEnum)[keyof typeof RefConferenceEventTypeScalarFieldEnum]


export const RefDiscountCategoryScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type RefDiscountCategoryScalarFieldEnum = (typeof RefDiscountCategoryScalarFieldEnum)[keyof typeof RefDiscountCategoryScalarFieldEnum]


export const RefEmailTemplateTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description'
} as const

export type RefEmailTemplateTypeScalarFieldEnum = (typeof RefEmailTemplateTypeScalarFieldEnum)[keyof typeof RefEmailTemplateTypeScalarFieldEnum]


export const RefGroupMeetingTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  group_id: 'group_id',
  description: 'description'
} as const

export type RefGroupMeetingTypeScalarFieldEnum = (typeof RefGroupMeetingTypeScalarFieldEnum)[keyof typeof RefGroupMeetingTypeScalarFieldEnum]


export const RefGroupRoleScalarFieldEnum = {
  group_role_id: 'group_role_id',
  society_id: 'society_id',
  group_id: 'group_id',
  group_admin: 'group_admin',
  description: 'description'
} as const

export type RefGroupRoleScalarFieldEnum = (typeof RefGroupRoleScalarFieldEnum)[keyof typeof RefGroupRoleScalarFieldEnum]


export const RefGroupTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description',
  additional_info_form_design: 'additional_info_form_design'
} as const

export type RefGroupTypeScalarFieldEnum = (typeof RefGroupTypeScalarFieldEnum)[keyof typeof RefGroupTypeScalarFieldEnum]


export const RefInstitutionSocietyUserRelationTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description'
} as const

export type RefInstitutionSocietyUserRelationTypeScalarFieldEnum = (typeof RefInstitutionSocietyUserRelationTypeScalarFieldEnum)[keyof typeof RefInstitutionSocietyUserRelationTypeScalarFieldEnum]


export const RefInstitutionTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description'
} as const

export type RefInstitutionTypeScalarFieldEnum = (typeof RefInstitutionTypeScalarFieldEnum)[keyof typeof RefInstitutionTypeScalarFieldEnum]


export const RefInteractionTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  name: 'name',
  form_design: 'form_design'
} as const

export type RefInteractionTypeScalarFieldEnum = (typeof RefInteractionTypeScalarFieldEnum)[keyof typeof RefInteractionTypeScalarFieldEnum]


export const RefProductGroupScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description',
  tax_record: 'tax_record'
} as const

export type RefProductGroupScalarFieldEnum = (typeof RefProductGroupScalarFieldEnum)[keyof typeof RefProductGroupScalarFieldEnum]


export const RefProductTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description',
  is_tag: 'is_tag'
} as const

export type RefProductTypeScalarFieldEnum = (typeof RefProductTypeScalarFieldEnum)[keyof typeof RefProductTypeScalarFieldEnum]


export const RefProfileAddressAndContactInformationTypeScalarFieldEnum = {
  ref_profile_address_contact_information_type_id: 'ref_profile_address_contact_information_type_id',
  society_id: 'society_id',
  ref_profile_address_contact_information_type_description: 'ref_profile_address_contact_information_type_description',
  id: 'id',
  description: 'description'
} as const

export type RefProfileAddressAndContactInformationTypeScalarFieldEnum = (typeof RefProfileAddressAndContactInformationTypeScalarFieldEnum)[keyof typeof RefProfileAddressAndContactInformationTypeScalarFieldEnum]


export const RefProfileAddressAndContactInformationUseScalarFieldEnum = {
  ref_profile_address_contact_information_use_id: 'ref_profile_address_contact_information_use_id',
  society_id: 'society_id',
  ref_profile_address_contact_information_use_description: 'ref_profile_address_contact_information_use_description',
  id: 'id',
  description: 'description'
} as const

export type RefProfileAddressAndContactInformationUseScalarFieldEnum = (typeof RefProfileAddressAndContactInformationUseScalarFieldEnum)[keyof typeof RefProfileAddressAndContactInformationUseScalarFieldEnum]


export const RefSocietySubmissionTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  icon: 'icon',
  description: 'description',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  position: 'position'
} as const

export type RefSocietySubmissionTypeScalarFieldEnum = (typeof RefSocietySubmissionTypeScalarFieldEnum)[keyof typeof RefSocietySubmissionTypeScalarFieldEnum]


export const RefSocietyUserRelationTypeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description'
} as const

export type RefSocietyUserRelationTypeScalarFieldEnum = (typeof RefSocietyUserRelationTypeScalarFieldEnum)[keyof typeof RefSocietyUserRelationTypeScalarFieldEnum]


export const ReviewInstanceScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  submission_definition_id: 'submission_definition_id',
  final_score: 'final_score',
  status: 'status',
  allow_modification: 'allow_modification',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  review_session_id: 'review_session_id',
  disclosure_instance_id: 'disclosure_instance_id',
  workflow_instance_id: 'workflow_instance_id'
} as const

export type ReviewInstanceScalarFieldEnum = (typeof ReviewInstanceScalarFieldEnum)[keyof typeof ReviewInstanceScalarFieldEnum]


export const ReviewInstanceAssignmentScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  review_session_id: 'review_session_id',
  review_session_member_id: 'review_session_member_id',
  review_instance_id: 'review_instance_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  assignment_reason: 'assignment_reason',
  recusal_reason: 'recusal_reason'
} as const

export type ReviewInstanceAssignmentScalarFieldEnum = (typeof ReviewInstanceAssignmentScalarFieldEnum)[keyof typeof ReviewInstanceAssignmentScalarFieldEnum]


export const ReviewInstanceVoteScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  review_instance_id: 'review_instance_id',
  profile_id: 'profile_id',
  canceled: 'canceled',
  vote_data: 'vote_data',
  score: 'score',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  review_instance_assignment_id: 'review_instance_assignment_id'
} as const

export type ReviewInstanceVoteScalarFieldEnum = (typeof ReviewInstanceVoteScalarFieldEnum)[keyof typeof ReviewInstanceVoteScalarFieldEnum]


export const ReviewReportScalarFieldEnum = {
  id: 'id',
  review_session_id: 'review_session_id',
  society_id: 'society_id',
  template: 'template',
  configurable_columns: 'configurable_columns',
  export_columns: 'export_columns',
  detailed_columns: 'detailed_columns'
} as const

export type ReviewReportScalarFieldEnum = (typeof ReviewReportScalarFieldEnum)[keyof typeof ReviewReportScalarFieldEnum]


export const ReviewSessionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  hub_instructions: 'hub_instructions',
  admin_notes: 'admin_notes',
  number_of_reviewers: 'number_of_reviewers',
  auto_show: 'auto_show',
  auto_hide: 'auto_hide',
  visible: 'visible',
  auto_close: 'auto_close',
  auto_open: 'auto_open',
  open: 'open',
  additional_info: 'additional_info',
  scorecard_form_id: 'scorecard_form_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  intelligent_assignment: 'intelligent_assignment',
  show_chart: 'show_chart',
  reports_enabled: 'reports_enabled',
  submission_template: 'submission_template',
  tab_template: 'tab_template',
  allow_recusals: 'allow_recusals'
} as const

export type ReviewSessionScalarFieldEnum = (typeof ReviewSessionScalarFieldEnum)[keyof typeof ReviewSessionScalarFieldEnum]


export const ReviewSessionFileScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  review_session_id: 'review_session_id',
  file_id: 'file_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ReviewSessionFileScalarFieldEnum = (typeof ReviewSessionFileScalarFieldEnum)[keyof typeof ReviewSessionFileScalarFieldEnum]


export const ReviewSessionMemberScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  review_session_id: 'review_session_id',
  profile_id: 'profile_id',
  disclosure_submission_instance_id: 'disclosure_submission_instance_id',
  expertise_submission_instance_id: 'expertise_submission_instance_id',
  disclosure_submission_definition_id: 'disclosure_submission_definition_id',
  expertise_submission_definition_id: 'expertise_submission_definition_id',
  role: 'role',
  will_review: 'will_review',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ReviewSessionMemberScalarFieldEnum = (typeof ReviewSessionMemberScalarFieldEnum)[keyof typeof ReviewSessionMemberScalarFieldEnum]


export const ReviewSessionSubmissionDefintionScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  review_session_id: 'review_session_id',
  submission_definition_id: 'submission_definition_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ReviewSessionSubmissionDefintionScalarFieldEnum = (typeof ReviewSessionSubmissionDefintionScalarFieldEnum)[keyof typeof ReviewSessionSubmissionDefintionScalarFieldEnum]


export const SSOConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  title: 'title',
  sso_saml_config_id: 'sso_saml_config_id',
  sso_journal_config_id: 'sso_journal_config_id',
  sso_path_lms_config_id: 'sso_path_lms_config_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  sso_oidc_config_id: 'sso_oidc_config_id'
} as const

export type SSOConfigScalarFieldEnum = (typeof SSOConfigScalarFieldEnum)[keyof typeof SSOConfigScalarFieldEnum]


export const SSOJournalConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  sso_journal_sage_config_id: 'sso_journal_sage_config_id',
  proxy_api: 'proxy_api',
  sso_journal_wiley_config_id: 'sso_journal_wiley_config_id',
  sso_journal_elsiver_config_id: 'sso_journal_elsiver_config_id'
} as const

export type SSOJournalConfigScalarFieldEnum = (typeof SSOJournalConfigScalarFieldEnum)[keyof typeof SSOJournalConfigScalarFieldEnum]


export const SSOJournalElsiverConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  target_url: 'target_url',
  domain: 'domain',
  redirect_user: 'redirect_user'
} as const

export type SSOJournalElsiverConfigScalarFieldEnum = (typeof SSOJournalElsiverConfigScalarFieldEnum)[keyof typeof SSOJournalElsiverConfigScalarFieldEnum]


export const SSOJournalSageConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  target_url: 'target_url',
  domain: 'domain',
  redirect_user: 'redirect_user'
} as const

export type SSOJournalSageConfigScalarFieldEnum = (typeof SSOJournalSageConfigScalarFieldEnum)[keyof typeof SSOJournalSageConfigScalarFieldEnum]


export const SSOJournalWileyConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  target_url: 'target_url',
  domain: 'domain',
  redirect_user: 'redirect_user'
} as const

export type SSOJournalWileyConfigScalarFieldEnum = (typeof SSOJournalWileyConfigScalarFieldEnum)[keyof typeof SSOJournalWileyConfigScalarFieldEnum]


export const SSOOIDCConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  client_id: 'client_id',
  client_secret: 'client_secret',
  callback_url: 'callback_url',
  response_type: 'response_type',
  state: 'state',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  attribute_list: 'attribute_list',
  public_jwk: 'public_jwk',
  private_jwk: 'private_jwk',
  cookie_secret: 'cookie_secret'
} as const

export type SSOOIDCConfigScalarFieldEnum = (typeof SSOOIDCConfigScalarFieldEnum)[keyof typeof SSOOIDCConfigScalarFieldEnum]


export const SSOPathLMSConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SSOPathLMSConfigScalarFieldEnum = (typeof SSOPathLMSConfigScalarFieldEnum)[keyof typeof SSOPathLMSConfigScalarFieldEnum]


export const SSOSAMLConfigScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  consumer_url: 'consumer_url',
  issuer: 'issuer',
  audience: 'audience',
  private_key: 'private_key',
  certificate: 'certificate',
  attribute_list: 'attribute_list',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SSOSAMLConfigScalarFieldEnum = (typeof SSOSAMLConfigScalarFieldEnum)[keyof typeof SSOSAMLConfigScalarFieldEnum]


export const SocietyBucketScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  name: 'name',
  region: 'region'
} as const

export type SocietyBucketScalarFieldEnum = (typeof SocietyBucketScalarFieldEnum)[keyof typeof SocietyBucketScalarFieldEnum]


export const SocietyCustomChoicesScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  society_custom_question_id: 'society_custom_question_id',
  text: 'text',
  value: 'value',
  archived: 'archived',
  priority: 'priority',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SocietyCustomChoicesScalarFieldEnum = (typeof SocietyCustomChoicesScalarFieldEnum)[keyof typeof SocietyCustomChoicesScalarFieldEnum]


export const SocietyCustomQuestionScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  question_name: 'question_name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  archived: 'archived'
} as const

export type SocietyCustomQuestionScalarFieldEnum = (typeof SocietyCustomQuestionScalarFieldEnum)[keyof typeof SocietyCustomQuestionScalarFieldEnum]


export const SocietyDashboardModuleScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  type: 'type',
  title: 'title',
  class_names: 'class_names',
  position_row: 'position_row',
  position_column: 'position_column',
  col_span: 'col_span',
  custom_report_id: 'custom_report_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  base_table: 'base_table',
  where_clause: 'where_clause',
  query_raw: 'query_raw',
  filter_config: 'filter_config',
  sets_config: 'sets_config',
  having_clause: 'having_clause',
  aggregate_statement: 'aggregate_statement',
  by_clause: 'by_clause',
  value_config: 'value_config',
  component_config: 'component_config',
  additional_info: 'additional_info'
} as const

export type SocietyDashboardModuleScalarFieldEnum = (typeof SocietyDashboardModuleScalarFieldEnum)[keyof typeof SocietyDashboardModuleScalarFieldEnum]


export const SocietySubmissionDefinitionScalarFieldEnum = {
  id: 'id',
  title: 'title',
  society_id: 'society_id',
  conference_id: 'conference_id',
  primary_form_id: 'primary_form_id',
  workflow_id: 'workflow_id',
  type: 'type',
  auto_open: 'auto_open',
  auto_close: 'auto_close',
  auto_visible: 'auto_visible',
  auto_hide: 'auto_hide',
  auto_secondary_cutoff: 'auto_secondary_cutoff',
  auto_cutoff: 'auto_cutoff',
  hub_template: 'hub_template',
  open: 'open',
  visible: 'visible',
  secondary_cutoff: 'secondary_cutoff',
  cutoff: 'cutoff',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  title_template: 'title_template',
  additional_info_template_short: 'additional_info_template_short',
  additional_info_template_detailed: 'additional_info_template_detailed',
  additional_info_participant_template: 'additional_info_participant_template',
  position: 'position',
  submission_print_template: 'submission_print_template'
} as const

export type SocietySubmissionDefinitionScalarFieldEnum = (typeof SocietySubmissionDefinitionScalarFieldEnum)[keyof typeof SocietySubmissionDefinitionScalarFieldEnum]


export const SocietySubmissionDefinitionTagScalarFieldEnum = {
  id: 'id',
  submission_definition_id: 'submission_definition_id',
  society_tag_id: 'society_tag_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type SocietySubmissionDefinitionTagScalarFieldEnum = (typeof SocietySubmissionDefinitionTagScalarFieldEnum)[keyof typeof SocietySubmissionDefinitionTagScalarFieldEnum]


export const SocietyUserCognitoIdentityProviderScalarFieldEnum = {
  id: 'id',
  identity_provider_id: 'identity_provider_id',
  pool_id: 'pool_id',
  client_id: 'client_id',
  pool_name: 'pool_name'
} as const

export type SocietyUserCognitoIdentityProviderScalarFieldEnum = (typeof SocietyUserCognitoIdentityProviderScalarFieldEnum)[keyof typeof SocietyUserCognitoIdentityProviderScalarFieldEnum]


export const SocietyUserIdentityScalarFieldEnum = {
  id: 'id',
  society_user_id: 'society_user_id',
  identity_provider_id: 'identity_provider_id',
  identity_value: 'identity_value',
  user_name: 'user_name',
  society_id: 'society_id',
  profile_id: 'profile_id'
} as const

export type SocietyUserIdentityScalarFieldEnum = (typeof SocietyUserIdentityScalarFieldEnum)[keyof typeof SocietyUserIdentityScalarFieldEnum]


export const SocietyUserIdentityProviderScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  type: 'type'
} as const

export type SocietyUserIdentityProviderScalarFieldEnum = (typeof SocietyUserIdentityProviderScalarFieldEnum)[keyof typeof SocietyUserIdentityProviderScalarFieldEnum]


export const SocietyUserLoginScalarFieldEnum = {
  id: 'id',
  society_user_id: 'society_user_id',
  method: 'method',
  login_at: 'login_at'
} as const

export type SocietyUserLoginScalarFieldEnum = (typeof SocietyUserLoginScalarFieldEnum)[keyof typeof SocietyUserLoginScalarFieldEnum]


export const SocietyUserRelationScalarFieldEnum = {
  id: 'id',
  society_user_id: 'society_user_id',
  related_to_society_user_id: 'related_to_society_user_id',
  type: 'type',
  copy_on_email: 'copy_on_email',
  additional_info: 'additional_info'
} as const

export type SocietyUserRelationScalarFieldEnum = (typeof SocietyUserRelationScalarFieldEnum)[keyof typeof SocietyUserRelationScalarFieldEnum]


export const SubmissionDefinitionFileScalarFieldEnum = {
  id: 'id',
  file_id: 'file_id',
  submission_definition_id: 'submission_definition_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SubmissionDefinitionFileScalarFieldEnum = (typeof SubmissionDefinitionFileScalarFieldEnum)[keyof typeof SubmissionDefinitionFileScalarFieldEnum]


export const TMBucketScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  name: 'name',
  active: 'active'
} as const

export type TMBucketScalarFieldEnum = (typeof TMBucketScalarFieldEnum)[keyof typeof TMBucketScalarFieldEnum]


export const TMCommentScalarFieldEnum = {
  id: 'id',
  task_id: 'task_id',
  author_id: 'author_id',
  comment: 'comment',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TMCommentScalarFieldEnum = (typeof TMCommentScalarFieldEnum)[keyof typeof TMCommentScalarFieldEnum]


export const TMSubtaskRefScalarFieldEnum = {
  primary_task_id: 'primary_task_id',
  subtask_id: 'subtask_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TMSubtaskRefScalarFieldEnum = (typeof TMSubtaskRefScalarFieldEnum)[keyof typeof TMSubtaskRefScalarFieldEnum]


export const TMSwimlaneScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  description: 'description',
  ordinal: 'ordinal',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  name: 'name'
} as const

export type TMSwimlaneScalarFieldEnum = (typeof TMSwimlaneScalarFieldEnum)[keyof typeof TMSwimlaneScalarFieldEnum]


export const TMTagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  hex_color: 'hex_color',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TMTagScalarFieldEnum = (typeof TMTagScalarFieldEnum)[keyof typeof TMTagScalarFieldEnum]


export const TMTaskScalarFieldEnum = {
  id: 'id',
  swim_lane_id: 'swim_lane_id',
  assignee_id: 'assignee_id',
  bucket_id: 'bucket_id',
  society_id: 'society_id',
  title: 'title',
  notes: 'notes',
  start_date: 'start_date',
  end_date: 'end_date',
  priority: 'priority',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TMTaskScalarFieldEnum = (typeof TMTaskScalarFieldEnum)[keyof typeof TMTaskScalarFieldEnum]


export const TMTaskDependencyScalarFieldEnum = {
  id: 'id',
  dependent_id: 'dependent_id',
  dependency_id: 'dependency_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TMTaskDependencyScalarFieldEnum = (typeof TMTaskDependencyScalarFieldEnum)[keyof typeof TMTaskDependencyScalarFieldEnum]


export const TMTaskTMTagScalarFieldEnum = {
  id: 'id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  tm_task_id: 'tm_task_id',
  tm_tag_id: 'tm_tag_id'
} as const

export type TMTaskTMTagScalarFieldEnum = (typeof TMTaskTMTagScalarFieldEnum)[keyof typeof TMTaskTMTagScalarFieldEnum]


export const TokenScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  value: 'value',
  expiration_date: 'expiration_date',
  usage_limit: 'usage_limit',
  expire_timer: 'expire_timer',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TokenScalarFieldEnum = (typeof TokenScalarFieldEnum)[keyof typeof TokenScalarFieldEnum]


export const TokenUsageFileScalarFieldEnum = {
  id: 'id',
  token_id: 'token_id',
  file_id: 'file_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TokenUsageFileScalarFieldEnum = (typeof TokenUsageFileScalarFieldEnum)[keyof typeof TokenUsageFileScalarFieldEnum]


export const TokenUsageLoginScalarFieldEnum = {
  id: 'id',
  token_id: 'token_id',
  society_user_id: 'society_user_id',
  path_param: 'path_param',
  profile_id: 'profile_id',
  route_path: 'route_path',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type TokenUsageLoginScalarFieldEnum = (typeof TokenUsageLoginScalarFieldEnum)[keyof typeof TokenUsageLoginScalarFieldEnum]


export const VenueScalarFieldEnum = {
  id: 'id',
  brand_id: 'brand_id',
  is_active: 'is_active',
  name: 'name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  timezone: 'timezone'
} as const

export type VenueScalarFieldEnum = (typeof VenueScalarFieldEnum)[keyof typeof VenueScalarFieldEnum]


export const VenueAddressScalarFieldEnum = {
  id: 'id',
  venue_id: 'venue_id',
  address_id: 'address_id',
  venue_address_name: 'venue_address_name',
  is_default: 'is_default'
} as const

export type VenueAddressScalarFieldEnum = (typeof VenueAddressScalarFieldEnum)[keyof typeof VenueAddressScalarFieldEnum]


export const VenueBrandScalarFieldEnum = {
  id: 'id',
  brand_name: 'brand_name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type VenueBrandScalarFieldEnum = (typeof VenueBrandScalarFieldEnum)[keyof typeof VenueBrandScalarFieldEnum]


export const VenueCombinationScalarFieldEnum = {
  id: 'id',
  venue_id: 'venue_id',
  parent_venue_id: 'parent_venue_id'
} as const

export type VenueCombinationScalarFieldEnum = (typeof VenueCombinationScalarFieldEnum)[keyof typeof VenueCombinationScalarFieldEnum]


export const VenueRoomLayoutScalarFieldEnum = {
  id: 'id',
  venue_id: 'venue_id',
  venue_room_id: 'venue_room_id',
  venue_room_layout_type: 'venue_room_layout_type',
  occupancy: 'occupancy',
  venue_room_layout_name: 'venue_room_layout_name',
  map_url: 'map_url',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type VenueRoomLayoutScalarFieldEnum = (typeof VenueRoomLayoutScalarFieldEnum)[keyof typeof VenueRoomLayoutScalarFieldEnum]


export const Email_opt_out_preferencesScalarFieldEnum = {
  id: 'id',
  contact_information_id: 'contact_information_id'
} as const

export type Email_opt_out_preferencesScalarFieldEnum = (typeof Email_opt_out_preferencesScalarFieldEnum)[keyof typeof Email_opt_out_preferencesScalarFieldEnum]


export const SSOOIDCSessionScalarFieldEnum = {
  sso_oidc_session_id: 'sso_oidc_session_id',
  grant_id: 'grant_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  society_user_id: 'society_user_id',
  access_token: 'access_token',
  session: 'session'
} as const

export type SSOOIDCSessionScalarFieldEnum = (typeof SSOOIDCSessionScalarFieldEnum)[keyof typeof SSOOIDCSessionScalarFieldEnum]


export const OIDCTransactionHistoryScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  type: 'type',
  payload: 'payload',
  grantId: 'grantId',
  userCode: 'userCode',
  uid: 'uid',
  expiresAt: 'expiresAt',
  consumedAt: 'consumedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
} as const

export type OIDCTransactionHistoryScalarFieldEnum = (typeof OIDCTransactionHistoryScalarFieldEnum)[keyof typeof OIDCTransactionHistoryScalarFieldEnum]


export const OptionalProductScalarFieldEnum = {
  optional_product_id: 'optional_product_id',
  society_id: 'society_id',
  allow_change_total: 'allow_change_total',
  pre_set_totals: 'pre_set_totals',
  allow_change_quantity: 'allow_change_quantity',
  allow_remove: 'allow_remove',
  allow_add: 'allow_add',
  allow_notes: 'allow_notes',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type OptionalProductScalarFieldEnum = (typeof OptionalProductScalarFieldEnum)[keyof typeof OptionalProductScalarFieldEnum]


export const CypressCoverageDataScalarFieldEnum = {
  id: 'id',
  lambda_instance_id: 'lambda_instance_id',
  test_run_id: 'test_run_id',
  coverage_json: 'coverage_json',
  file_count: 'file_count',
  request_count: 'request_count',
  created_at: 'created_at',
  last_updated: 'last_updated'
} as const

export type CypressCoverageDataScalarFieldEnum = (typeof CypressCoverageDataScalarFieldEnum)[keyof typeof CypressCoverageDataScalarFieldEnum]


export const CustomReportTagEveryScalarFieldEnum = {
  id: 'id',
  custom_report_id: 'custom_report_id',
  society_tag_id: 'society_tag_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type CustomReportTagEveryScalarFieldEnum = (typeof CustomReportTagEveryScalarFieldEnum)[keyof typeof CustomReportTagEveryScalarFieldEnum]


export const CustomReportTagNoneScalarFieldEnum = {
  id: 'id',
  custom_report_id: 'custom_report_id',
  society_tag_id: 'society_tag_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type CustomReportTagNoneScalarFieldEnum = (typeof CustomReportTagNoneScalarFieldEnum)[keyof typeof CustomReportTagNoneScalarFieldEnum]


export const CustomReportTagSomeScalarFieldEnum = {
  id: 'id',
  custom_report_id: 'custom_report_id',
  society_tag_id: 'society_tag_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type CustomReportTagSomeScalarFieldEnum = (typeof CustomReportTagSomeScalarFieldEnum)[keyof typeof CustomReportTagSomeScalarFieldEnum]


export const SocietyDashboardModuleTagEveryScalarFieldEnum = {
  id: 'id',
  society_dashboard_module_id: 'society_dashboard_module_id',
  society_tag_id: 'society_tag_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SocietyDashboardModuleTagEveryScalarFieldEnum = (typeof SocietyDashboardModuleTagEveryScalarFieldEnum)[keyof typeof SocietyDashboardModuleTagEveryScalarFieldEnum]


export const SocietyDashboardModuleTagNoneScalarFieldEnum = {
  id: 'id',
  society_dashboard_module_id: 'society_dashboard_module_id',
  society_tag_id: 'society_tag_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SocietyDashboardModuleTagNoneScalarFieldEnum = (typeof SocietyDashboardModuleTagNoneScalarFieldEnum)[keyof typeof SocietyDashboardModuleTagNoneScalarFieldEnum]


export const SocietyDashboardModuleTagSomeScalarFieldEnum = {
  id: 'id',
  society_dashboard_module_id: 'society_dashboard_module_id',
  society_tag_id: 'society_tag_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SocietyDashboardModuleTagSomeScalarFieldEnum = (typeof SocietyDashboardModuleTagSomeScalarFieldEnum)[keyof typeof SocietyDashboardModuleTagSomeScalarFieldEnum]


export const NotificationSubscriptionScalarFieldEnum = {
  notification_subscription_id: 'notification_subscription_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  device_identifier: 'device_identifier',
  push_token: 'push_token',
  platform: 'platform',
  device_name: 'device_name',
  app_version: 'app_version',
  os_version: 'os_version',
  is_active: 'is_active',
  last_used_at: 'last_used_at',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type NotificationSubscriptionScalarFieldEnum = (typeof NotificationSubscriptionScalarFieldEnum)[keyof typeof NotificationSubscriptionScalarFieldEnum]


export const WorkflowInstancePayloadHistoricScalarFieldEnum = {
  workflow_instance_payload_historic_id: 'workflow_instance_payload_historic_id',
  society_id: 'society_id',
  workflow_instance_id: 'workflow_instance_id',
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  state_name: 'state_name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type WorkflowInstancePayloadHistoricScalarFieldEnum = (typeof WorkflowInstancePayloadHistoricScalarFieldEnum)[keyof typeof WorkflowInstancePayloadHistoricScalarFieldEnum]


export const WebSocketConnectionScalarFieldEnum = {
  websocket_connection_id: 'websocket_connection_id',
  external_connection_string: 'external_connection_string',
  society_id: 'society_id',
  profile_id: 'profile_id',
  notification_subscription_id: 'notification_subscription_id',
  route_key: 'route_key',
  connection_metadata: 'connection_metadata',
  is_active: 'is_active',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  device_identifier: 'device_identifier'
} as const

export type WebSocketConnectionScalarFieldEnum = (typeof WebSocketConnectionScalarFieldEnum)[keyof typeof WebSocketConnectionScalarFieldEnum]


export const NotificationEventScalarFieldEnum = {
  notification_event_id: 'notification_event_id',
  event_type: 'event_type',
  society_id: 'society_id',
  notification_title: 'notification_title',
  notification_body: 'notification_body',
  event_data: 'event_data',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  chat_id: 'chat_id'
} as const

export type NotificationEventScalarFieldEnum = (typeof NotificationEventScalarFieldEnum)[keyof typeof NotificationEventScalarFieldEnum]


export const NotificationEventRecipientScalarFieldEnum = {
  notification_event_recipient_id: 'notification_event_recipient_id',
  notification_event_id: 'notification_event_id',
  profile_id: 'profile_id',
  society_id: 'society_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  status: 'status'
} as const

export type NotificationEventRecipientScalarFieldEnum = (typeof NotificationEventRecipientScalarFieldEnum)[keyof typeof NotificationEventRecipientScalarFieldEnum]


export const SocietyDefaultReportScalarFieldEnum = {
  society_default_report_id: 'society_default_report_id',
  society_id: 'society_id',
  custom_report_id: 'custom_report_id',
  society_admin_id: 'society_admin_id',
  base_table: 'base_table',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type SocietyDefaultReportScalarFieldEnum = (typeof SocietyDefaultReportScalarFieldEnum)[keyof typeof SocietyDefaultReportScalarFieldEnum]


export const ConferenceEventAttendeeScalarFieldEnum = {
  conference_event_attendee_id: 'conference_event_attendee_id',
  conference_id: 'conference_id',
  conference_event_id: 'conference_event_id',
  profile_id: 'profile_id',
  conference_registration_id: 'conference_registration_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceEventAttendeeScalarFieldEnum = (typeof ConferenceEventAttendeeScalarFieldEnum)[keyof typeof ConferenceEventAttendeeScalarFieldEnum]


export const ConferenceEventFavoriteScalarFieldEnum = {
  conference_event_favorite_id: 'conference_event_favorite_id',
  conference_id: 'conference_id',
  conference_event_id: 'conference_event_id',
  profile_id: 'profile_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ConferenceEventFavoriteScalarFieldEnum = (typeof ConferenceEventFavoriteScalarFieldEnum)[keyof typeof ConferenceEventFavoriteScalarFieldEnum]


export const RefCountryScalarFieldEnum = {
  ref_country_id: 'ref_country_id',
  society_id: 'society_id',
  list_order: 'list_order',
  name: 'name',
  iso_code: 'iso_code',
  abbreviation: 'abbreviation',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type RefCountryScalarFieldEnum = (typeof RefCountryScalarFieldEnum)[keyof typeof RefCountryScalarFieldEnum]


export const RefCountryClassificationCategoryScalarFieldEnum = {
  ref_country_classification_category_id: 'ref_country_classification_category_id',
  society_id: 'society_id',
  list_order: 'list_order',
  name: 'name',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type RefCountryClassificationCategoryScalarFieldEnum = (typeof RefCountryClassificationCategoryScalarFieldEnum)[keyof typeof RefCountryClassificationCategoryScalarFieldEnum]


export const RefCountryClassificationScalarFieldEnum = {
  country_classification_id: 'country_classification_id',
  ref_country_id: 'ref_country_id',
  ref_country_classification_category_id: 'ref_country_classification_category_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type RefCountryClassificationScalarFieldEnum = (typeof RefCountryClassificationScalarFieldEnum)[keyof typeof RefCountryClassificationScalarFieldEnum]


export const ProductPricingCountryClassificationScalarFieldEnum = {
  product_pricing_country_classification_id: 'product_pricing_country_classification_id',
  society_id: 'society_id',
  product_id: 'product_id',
  country_classification_id: 'country_classification_id',
  price: 'price',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ProductPricingCountryClassificationScalarFieldEnum = (typeof ProductPricingCountryClassificationScalarFieldEnum)[keyof typeof ProductPricingCountryClassificationScalarFieldEnum]


export const MembershipMetaScalarFieldEnum = {
  membership_id: 'membership_id',
  profile_id: 'profile_id',
  society_id: 'society_id',
  product_id: 'product_id',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  termination_date: 'termination_date',
  prev_effective_date: 'prev_effective_date',
  prev_expiration_date: 'prev_expiration_date',
  is_latest: 'is_latest',
  join_date: 'join_date'
} as const

export type MembershipMetaScalarFieldEnum = (typeof MembershipMetaScalarFieldEnum)[keyof typeof MembershipMetaScalarFieldEnum]


export const ProfileInvoiceNoteScalarFieldEnum = {
  profile_invoice_note_id: 'profile_invoice_note_id',
  profile_note_id: 'profile_note_id',
  invoice_id: 'invoice_id',
  body: 'body',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ProfileInvoiceNoteScalarFieldEnum = (typeof ProfileInvoiceNoteScalarFieldEnum)[keyof typeof ProfileInvoiceNoteScalarFieldEnum]


export const ProfileNoteScalarFieldEnum = {
  profile_note_id: 'profile_note_id',
  profile_id: 'profile_id',
  subject: 'subject',
  society_id: 'society_id'
} as const

export type ProfileNoteScalarFieldEnum = (typeof ProfileNoteScalarFieldEnum)[keyof typeof ProfileNoteScalarFieldEnum]


export const ProfileNoteStandardScalarFieldEnum = {
  profile_note_standard_id: 'profile_note_standard_id',
  profile_note_id: 'profile_note_id',
  body: 'body',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  society_id: 'society_id'
} as const

export type ProfileNoteStandardScalarFieldEnum = (typeof ProfileNoteStandardScalarFieldEnum)[keyof typeof ProfileNoteStandardScalarFieldEnum]


export const ChatBlockScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  blocked_by_profile_id: 'blocked_by_profile_id',
  blocked_profile_id: 'blocked_profile_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type ChatBlockScalarFieldEnum = (typeof ChatBlockScalarFieldEnum)[keyof typeof ChatBlockScalarFieldEnum]


export const McpOAuthRecordScalarFieldEnum = {
  id: 'id',
  type: 'type',
  payload: 'payload',
  grant_id: 'grant_id',
  user_code: 'user_code',
  uid: 'uid',
  expires_at: 'expires_at',
  consumed_at: 'consumed_at',
  created_at: 'created_at',
  updated_at: 'updated_at'
} as const

export type McpOAuthRecordScalarFieldEnum = (typeof McpOAuthRecordScalarFieldEnum)[keyof typeof McpOAuthRecordScalarFieldEnum]


export const McpConnectionScalarFieldEnum = {
  id: 'id',
  grant_id: 'grant_id',
  society_admin_id: 'society_admin_id',
  client_id: 'client_id',
  client_name: 'client_name',
  scopes: 'scopes',
  deployment_id: 'deployment_id',
  created_at: 'created_at',
  last_used_at: 'last_used_at',
  revoked_at: 'revoked_at'
} as const

export type McpConnectionScalarFieldEnum = (typeof McpConnectionScalarFieldEnum)[keyof typeof McpConnectionScalarFieldEnum]


export const McpConnectionSocietyScalarFieldEnum = {
  mcp_connection_id: 'mcp_connection_id',
  society_id: 'society_id'
} as const

export type McpConnectionSocietyScalarFieldEnum = (typeof McpConnectionSocietyScalarFieldEnum)[keyof typeof McpConnectionSocietyScalarFieldEnum]


export const McpAuditLogScalarFieldEnum = {
  id: 'id',
  mcp_connection_id: 'mcp_connection_id',
  society_admin_id: 'society_admin_id',
  society_id: 'society_id',
  tool_name: 'tool_name',
  arguments: 'arguments',
  row_count: 'row_count',
  status: 'status',
  error: 'error',
  duration_ms: 'duration_ms',
  created_at: 'created_at'
} as const

export type McpAuditLogScalarFieldEnum = (typeof McpAuditLogScalarFieldEnum)[keyof typeof McpAuditLogScalarFieldEnum]


export const McpRecipeScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  title: 'title',
  summary: 'summary',
  body: 'body',
  shared: 'shared',
  archived: 'archived',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id'
} as const

export type McpRecipeScalarFieldEnum = (typeof McpRecipeScalarFieldEnum)[keyof typeof McpRecipeScalarFieldEnum]


export const AppRouteConfigDirectoryTableViewScalarFieldEnum = {
  app_route_config_id: 'app_route_config_id',
  directory_id: 'directory_id',
  society_id: 'society_id'
} as const

export type AppRouteConfigDirectoryTableViewScalarFieldEnum = (typeof AppRouteConfigDirectoryTableViewScalarFieldEnum)[keyof typeof AppRouteConfigDirectoryTableViewScalarFieldEnum]


export const AppRouteConfigCustomReportTableViewScalarFieldEnum = {
  app_route_config_id: 'app_route_config_id',
  custom_report_id: 'custom_report_id',
  param_key: 'param_key',
  society_id: 'society_id'
} as const

export type AppRouteConfigCustomReportTableViewScalarFieldEnum = (typeof AppRouteConfigCustomReportTableViewScalarFieldEnum)[keyof typeof AppRouteConfigCustomReportTableViewScalarFieldEnum]


export const LatestMembershipTableViewScalarFieldEnum = {
  membership_id: 'membership_id',
  profile_id: 'profile_id',
  society_id: 'society_id',
  product_id: 'product_id',
  join_date: 'join_date',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  termination_date: 'termination_date',
  workflow_instance_id: 'workflow_instance_id',
  invoice_item_id: 'invoice_item_id',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  ref_membership_status_id: 'ref_membership_status_id'
} as const

export type LatestMembershipTableViewScalarFieldEnum = (typeof LatestMembershipTableViewScalarFieldEnum)[keyof typeof LatestMembershipTableViewScalarFieldEnum]


export const MembershipTableViewScalarFieldEnum = {
  membership_id: 'membership_id',
  profile_id: 'profile_id',
  society_id: 'society_id',
  product_id: 'product_id',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  termination_date: 'termination_date',
  join_date: 'join_date',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  workflow_instance_id: 'workflow_instance_id',
  invoice_item_id: 'invoice_item_id',
  ref_membership_status_id: 'ref_membership_status_id',
  membership_grace_period: 'membership_grace_period',
  membership_include_lapsed: 'membership_include_lapsed',
  active_since_last: 'active_since_last'
} as const

export type MembershipTableViewScalarFieldEnum = (typeof MembershipTableViewScalarFieldEnum)[keyof typeof MembershipTableViewScalarFieldEnum]


export const SocietySettingPublicScalarFieldEnum = {
  id: 'id',
  society_id: 'society_id',
  name: 'name',
  type: 'type',
  secret: 'secret',
  value: 'value'
} as const

export type SocietySettingPublicScalarFieldEnum = (typeof SocietySettingPublicScalarFieldEnum)[keyof typeof SocietySettingPublicScalarFieldEnum]


export const DynamicProfileTagTableViewScalarFieldEnum = {
  society_id: 'society_id',
  profile_id: 'profile_id',
  society_tag_id: 'society_tag_id',
  group_member_id: 'group_member_id',
  membership_id: 'membership_id',
  visible: 'visible',
  visible_admin: 'visible_admin',
  product_id: 'product_id',
  tag_name: 'tag_name',
  type: 'type'
} as const

export type DynamicProfileTagTableViewScalarFieldEnum = (typeof DynamicProfileTagTableViewScalarFieldEnum)[keyof typeof DynamicProfileTagTableViewScalarFieldEnum]


export const DistinctMembershipSocietyViewScalarFieldEnum = {
  society_id: 'society_id',
  product_id: 'product_id'
} as const

export type DistinctMembershipSocietyViewScalarFieldEnum = (typeof DistinctMembershipSocietyViewScalarFieldEnum)[keyof typeof DistinctMembershipSocietyViewScalarFieldEnum]


export const DynamicSocietyTagTableViewScalarFieldEnum = {
  society_id: 'society_id',
  society_tag_id: 'society_tag_id',
  group_id: 'group_id',
  product_id: 'product_id',
  visible: 'visible',
  visible_admin: 'visible_admin',
  tag_name: 'tag_name'
} as const

export type DynamicSocietyTagTableViewScalarFieldEnum = (typeof DynamicSocietyTagTableViewScalarFieldEnum)[keyof typeof DynamicSocietyTagTableViewScalarFieldEnum]


export const WorkflowInstancePayloadProfileSearchTableViewScalarFieldEnum = {
  society_id: 'society_id',
  parent_workflow_instance_id: 'parent_workflow_instance_id',
  question_name: 'question_name',
  question_value_role: 'question_value_role',
  question_value_position: 'question_value_position',
  question_value_workflow_instance_id: 'question_value_workflow_instance_id',
  question_value_profile_id: 'question_value_profile_id',
  question_value_payload: 'question_value_payload'
} as const

export type WorkflowInstancePayloadProfileSearchTableViewScalarFieldEnum = (typeof WorkflowInstancePayloadProfileSearchTableViewScalarFieldEnum)[keyof typeof WorkflowInstancePayloadProfileSearchTableViewScalarFieldEnum]


export const WorkflowInstancePayloadPanelDynamicTableViewScalarFieldEnum = {
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  profile_id: 'profile_id',
  element_name: 'element_name',
  dynamic_panel_element: 'dynamic_panel_element',
  element_position: 'element_position',
  society_id: 'society_id'
} as const

export type WorkflowInstancePayloadPanelDynamicTableViewScalarFieldEnum = (typeof WorkflowInstancePayloadPanelDynamicTableViewScalarFieldEnum)[keyof typeof WorkflowInstancePayloadPanelDynamicTableViewScalarFieldEnum]


export const WorkflowInstancePayloadDateTableViewScalarFieldEnum = {
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  profile_id: 'profile_id',
  question_name: 'question_name',
  society_id: 'society_id',
  workflow_instance_id: 'workflow_instance_id',
  question_value_date: 'question_value_date',
  question_value_payload: 'question_value_payload'
} as const

export type WorkflowInstancePayloadDateTableViewScalarFieldEnum = (typeof WorkflowInstancePayloadDateTableViewScalarFieldEnum)[keyof typeof WorkflowInstancePayloadDateTableViewScalarFieldEnum]


export const WorkflowInstancePayloadScalarTableViewScalarFieldEnum = {
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  profile_id: 'profile_id',
  workflow_instance_id: 'workflow_instance_id',
  society_id: 'society_id',
  form_id: 'form_id',
  question_name: 'question_name',
  question_type: 'question_type',
  question_value: 'question_value'
} as const

export type WorkflowInstancePayloadScalarTableViewScalarFieldEnum = (typeof WorkflowInstancePayloadScalarTableViewScalarFieldEnum)[keyof typeof WorkflowInstancePayloadScalarTableViewScalarFieldEnum]


export const WorkflowInstancePayloadEducationInstanceTableViewScalarFieldEnum = {
  society_id: 'society_id',
  workflow_instance_id: 'workflow_instance_id',
  workflow_instance_profile_id: 'workflow_instance_profile_id',
  education_instance_id: 'education_instance_id',
  question_name: 'question_name',
  question_value_payload: 'question_value_payload',
  question_value_hours_to_use: 'question_value_hours_to_use',
  question_value_education_instance_id: 'question_value_education_instance_id',
  question_value_override_name: 'question_value_override_name'
} as const

export type WorkflowInstancePayloadEducationInstanceTableViewScalarFieldEnum = (typeof WorkflowInstancePayloadEducationInstanceTableViewScalarFieldEnum)[keyof typeof WorkflowInstancePayloadEducationInstanceTableViewScalarFieldEnum]


export const InvoiceTableViewScalarFieldEnum = {
  invoice_id: 'invoice_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  billing_id: 'billing_id',
  shipping_id: 'shipping_id',
  status: 'status',
  payment_terms: 'payment_terms',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  workflow_instance_id: 'workflow_instance_id',
  id_as_string: 'id_as_string',
  sales_tax_id: 'sales_tax_id',
  subtotal_sum: 'subtotal_sum',
  sales_tax_sum: 'sales_tax_sum',
  total_sum: 'total_sum',
  payments_sum: 'payments_sum'
} as const

export type InvoiceTableViewScalarFieldEnum = (typeof InvoiceTableViewScalarFieldEnum)[keyof typeof InvoiceTableViewScalarFieldEnum]


export const InvoiceItemTableViewScalarFieldEnum = {
  invoice_item_id: 'invoice_item_id',
  invoice_id: 'invoice_id',
  workflow_instance_id: 'workflow_instance_id',
  product_id: 'product_id',
  status: 'status',
  effective_date: 'effective_date',
  expiration_date: 'expiration_date',
  quantity: 'quantity',
  price: 'price',
  total: 'total',
  cash_gl_account: 'cash_gl_account',
  income_gl_account: 'income_gl_account',
  classification: 'classification',
  additional_info: 'additional_info',
  society_id: 'society_id',
  profile_id: 'profile_id',
  original_invoice_item_id: 'original_invoice_item_id',
  sales_tax_id: 'sales_tax_id',
  invoice_item_product_name: 'invoice_item_product_name',
  product_type_id: 'product_type_id',
  product_inventory_id: 'product_inventory_id',
  product_name: 'product_name',
  product_sku: 'product_sku',
  product_range_mm_start: 'product_range_mm_start',
  product_range_mm_end: 'product_range_mm_end',
  product_range_dd_start: 'product_range_dd_start',
  product_range_dd_end: 'product_range_dd_end',
  product_length_increment: 'product_length_increment',
  product_length_multiple: 'product_length_multiple',
  product_duration_type: 'product_duration_type',
  product_reccurring: 'product_reccurring',
  product_current_sub_name: 'product_current_sub_name',
  workflow_instance_current_state: 'workflow_instance_current_state',
  workflow_instance_state_history: 'workflow_instance_state_history',
  workflow_instance_status: 'workflow_instance_status',
  workflow_instance_possible_actions: 'workflow_instance_possible_actions',
  workflow_instance_display_status: 'workflow_instance_display_status',
  workflow_instance_payload_id: 'workflow_instance_payload_id'
} as const

export type InvoiceItemTableViewScalarFieldEnum = (typeof InvoiceItemTableViewScalarFieldEnum)[keyof typeof InvoiceItemTableViewScalarFieldEnum]


export const InvoicePaymentTableViewScalarFieldEnum = {
  invoice_id: 'invoice_id',
  payment_id: 'payment_id',
  society_id: 'society_id',
  profile_id: 'profile_id',
  payment_method: 'payment_method',
  status: 'status',
  transaction_id: 'transaction_id',
  paid_amount: 'paid_amount',
  settlement_date: 'settlement_date',
  settlement_batch_id: 'settlement_batch_id',
  reconciliation_batch_id: 'reconciliation_batch_id',
  additional_info: 'additional_info',
  created_id: 'created_id',
  last_modified_id: 'last_modified_id',
  id_as_string: 'id_as_string'
} as const

export type InvoicePaymentTableViewScalarFieldEnum = (typeof InvoicePaymentTableViewScalarFieldEnum)[keyof typeof InvoicePaymentTableViewScalarFieldEnum]


export const FormDesignQuestionViewScalarFieldEnum = {
  form_id: 'form_id',
  society_id: 'society_id',
  name: 'name',
  type: 'type',
  element_json: 'element_json'
} as const

export type FormDesignQuestionViewScalarFieldEnum = (typeof FormDesignQuestionViewScalarFieldEnum)[keyof typeof FormDesignQuestionViewScalarFieldEnum]


export const FormDesignProductQuestionViewScalarFieldEnum = {
  form_id: 'form_id',
  society_id: 'society_id',
  question_name: 'question_name',
  product_id: 'product_id',
  is_multiple_choice: 'is_multiple_choice'
} as const

export type FormDesignProductQuestionViewScalarFieldEnum = (typeof FormDesignProductQuestionViewScalarFieldEnum)[keyof typeof FormDesignProductQuestionViewScalarFieldEnum]


export const FormDesignProfileSearchQuestionViewScalarFieldEnum = {
  form_id: 'form_id',
  society_id: 'society_id',
  question_name: 'question_name',
  question_type: 'question_type',
  question_title: 'question_title',
  directory_id: 'directory_id',
  new_profile_workflow_id: 'new_profile_workflow_id',
  element_json: 'element_json'
} as const

export type FormDesignProfileSearchQuestionViewScalarFieldEnum = (typeof FormDesignProfileSearchQuestionViewScalarFieldEnum)[keyof typeof FormDesignProfileSearchQuestionViewScalarFieldEnum]


export const WorkflowInstancePayloadCertificationAttributionTableViewScalarFieldEnum = {
  society_id: 'society_id',
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  profile_id: 'profile_id',
  workflow_id: 'workflow_id',
  hours_to_use: 'hours_to_use',
  certification_definition_id: 'certification_definition_id',
  element_position: 'element_position',
  element_name: 'element_name',
  dynamic_panel_element: 'dynamic_panel_element'
} as const

export type WorkflowInstancePayloadCertificationAttributionTableViewScalarFieldEnum = (typeof WorkflowInstancePayloadCertificationAttributionTableViewScalarFieldEnum)[keyof typeof WorkflowInstancePayloadCertificationAttributionTableViewScalarFieldEnum]


export const WorkflowDefinitionTableViewScalarFieldEnum = {
  workflow_id: 'workflow_id',
  workflow_name: 'workflow_name',
  society_id: 'society_id',
  state_name: 'state_name',
  state_type: 'state_type',
  state_description: 'state_description',
  display_status: 'display_status',
  next_state: 'next_state',
  state_function: 'state_function',
  state_config: 'state_config',
  possible_actions: 'possible_actions',
  userhub_redirect: 'userhub_redirect',
  transitions: 'transitions',
  admin_form: 'admin_form',
  entry_event: 'entry_event',
  admin_display_priority: 'admin_display_priority'
} as const

export type WorkflowDefinitionTableViewScalarFieldEnum = (typeof WorkflowDefinitionTableViewScalarFieldEnum)[keyof typeof WorkflowDefinitionTableViewScalarFieldEnum]


export const WorkflowInstancePayloadProductTableViewScalarFieldEnum = {
  form_id: 'form_id',
  profile_id: 'profile_id',
  workflow_instance_payload_id: 'workflow_instance_payload_id',
  society_id: 'society_id',
  question_name: 'question_name',
  is_multiple_choice: 'is_multiple_choice',
  quantity: 'quantity',
  invoice_id: 'invoice_id',
  product_id: 'product_id',
  invoice_item_id: 'invoice_item_id'
} as const

export type WorkflowInstancePayloadProductTableViewScalarFieldEnum = (typeof WorkflowInstancePayloadProductTableViewScalarFieldEnum)[keyof typeof WorkflowInstancePayloadProductTableViewScalarFieldEnum]


export const FormDesignQuestionMetaViewScalarFieldEnum = {
  form_id: 'form_id',
  society_id: 'society_id',
  name: 'name',
  type: 'type',
  element_json: 'element_json'
} as const

export type FormDesignQuestionMetaViewScalarFieldEnum = (typeof FormDesignQuestionMetaViewScalarFieldEnum)[keyof typeof FormDesignQuestionMetaViewScalarFieldEnum]


export const SortOrder = {
  asc: 'asc',
  desc: 'desc'
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]


export const NullableJsonNullValueInput = {
  DbNull: DbNull,
  JsonNull: JsonNull
} as const

export type NullableJsonNullValueInput = (typeof NullableJsonNullValueInput)[keyof typeof NullableJsonNullValueInput]


export const JsonNullValueInput = {
  JsonNull: JsonNull
} as const

export type JsonNullValueInput = (typeof JsonNullValueInput)[keyof typeof JsonNullValueInput]


export const QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
} as const

export type QueryMode = (typeof QueryMode)[keyof typeof QueryMode]


export const NullsOrder = {
  first: 'first',
  last: 'last'
} as const

export type NullsOrder = (typeof NullsOrder)[keyof typeof NullsOrder]


export const JsonNullValueFilter = {
  DbNull: DbNull,
  JsonNull: JsonNull,
  AnyNull: AnyNull
} as const

export type JsonNullValueFilter = (typeof JsonNullValueFilter)[keyof typeof JsonNullValueFilter]

